function _0x3817() {
  const _0x642267 = ["45647ZqXWfx", "GatOu", "connection-restoring-completed", "connection-restoring-error", "disconnection", "TRANSACTION_SIGNING_FAILED", "38015BXRBhn", "purchase-init", "WALLET_CONNECT_SUCCESS", "transaction-signed", "WALLET_CONNECT_ERROR", "split", "etyKY", "jnzgu", "zVEQj", "purchase-success", "lXgHz", "connection-started", "QqHDX", "ayBUj", "CONNECTION_RESTORING_ERROR", "custom-event", "CONNECTION_RESTORING_STARTED", "connection-error", "lfgxj", "app-init", "WALLET_DISCONNECT", "167256YbZzDV", "HIDE", "subscription-renewed", "TRANSACTION_SENT_FOR_SIGNATURE", "WALLET_CONNECT_STARTED", "register-invoice", "12123234okuZDh", "KeQKq", "subscription-cancelled", "nNTuJ", "transaction-signing-failed", "Sklux", "UYjrr", "380pBZoFU", "app-hide", "subscription-started", "PURCHASE_FAILED", "BYnJp", "SUBSCRIPTION_STARTED", "27525700xGNeYw", "connection-restoring-started", "PCYip", "connection-completed", "492477JHhGEv", "purchase-failed", "CUSTOM_EVENT", "234446LuDyHv", "plczn", "ADDITIONAL_TASK_EVENT", "hWtDc", "8vdncIb", "Jlyav", "REFUND_ISSUED", "SUBSCRIPTION_RENEWED", "INIT", "anIez", "852QKXMxz", "INVOICE_REGISTERED", "KaYbK", "PURCHASE_INIT", "TRANSACTION_SIGNED", "20|13|3|10|22|7|8|1|11|21|14|17|9|12|15|19|2|4|5|6|16|0|18", "PURCHASE_SUCCESS", "HGkeS"];
  _0x3817 = function() {
    return _0x642267;
  };
  return _0x3817();
}
(function(_0x15232e, _0x452630) {
  const _0x78c8ca = _0x5a46, _0x196083 = _0x15232e();
  while (!![]) {
    try {
      const _0x186e47 = -parseInt(_0x78c8ca(222)) / 1 + -parseInt(_0x78c8ca(196)) / 2 + -parseInt(_0x78c8ca(219)) / 3 + parseInt(_0x78c8ca(209)) / 4 * (parseInt(_0x78c8ca(175)) / 5) + parseInt(_0x78c8ca(161)) / 6 * (-parseInt(_0x78c8ca(169)) / 7) + -parseInt(_0x78c8ca(155)) / 8 * (parseInt(_0x78c8ca(202)) / 9) + parseInt(_0x78c8ca(215)) / 10;
      if (_0x186e47 === _0x452630) break;
      else _0x196083["push"](_0x196083["shift"]());
    } catch (_0x22c7a0) {
      _0x196083["push"](_0x196083["shift"]());
    }
  }
})(_0x3817, 719614);
const BACKEND_URL = "https://tganalytics.xyz/";
function _0x5a46(_0x26c20e, _0x59c8da) {
  const _0x381719 = _0x3817();
  return _0x5a46 = function(_0x5a462f, _0x142fc0) {
    _0x5a462f = _0x5a462f - 154;
    let _0x5c3bb7 = _0x381719[_0x5a462f];
    return _0x5c3bb7;
  }, _0x5a46(_0x26c20e, _0x59c8da);
}
const STAGING_BACKEND_URL = "https://staging.tganalytics.xyz/";
const BATCH_KEY = "TGA-Batch-Requests";
var Events = ((_0x2baf30) => {
  const _0x5d94b7 = _0x5a46, _0x2ce1c9 = { "plczn": _0x5d94b7(166), "lXgHz": _0x5d94b7(162), "PCYip": "CONNECTION_RESTORING_SUCCESS", "MfurE": _0x5d94b7(171), "gQHPS": _0x5d94b7(220), "HGkeS": _0x5d94b7(221), "Jlyav": _0x5d94b7(190), "KaYbK": _0x5d94b7(157), "UpayM": "refund-issued", "BJSgp": _0x5d94b7(211), "JEuAN": _0x5d94b7(158), "lfgxj": _0x5d94b7(198), "hWtDc": _0x5d94b7(179), "VrGay": _0x5d94b7(192), "SyQCB": _0x5d94b7(191), "ayBUj": _0x5d94b7(216), "BYnJp": _0x5d94b7(195), "zVEQj": _0x5d94b7(172), "nNTuJ": _0x5d94b7(224), "anIez": _0x5d94b7(210), "Sklux": _0x5d94b7(164), "QqHDX": "SUBSCRIPTION_CANCELLED", "oaaGh": _0x5d94b7(204), "ghLgm": _0x5d94b7(174), "UYjrr": _0x5d94b7(167), "KeQKq": _0x5d94b7(184), "GatOu": _0x5d94b7(159), "jnzgu": _0x5d94b7(194), "RJXSH": _0x5d94b7(199), "etyKY": "transaction-sent-for-signature", "BsMJa": _0x5d94b7(218) }, _0x5ef177 = _0x2ce1c9[_0x5d94b7(223)][_0x5d94b7(180)]("|");
  let _0x44ea5a = 0;
  while (!![]) {
    switch (_0x5ef177[_0x44ea5a++]) {
      case "0":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(185)]] = _0x5d94b7(201);
        continue;
      case "1":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(217)]] = _0x2ce1c9["MfurE"];
        continue;
      case "2":
        _0x2baf30[_0x5d94b7(212)] = _0x2ce1c9["gQHPS"];
        continue;
      case "3":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(168)]] = _0x2ce1c9[_0x5d94b7(156)];
        continue;
      case "4":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(163)]] = _0x2ce1c9["UpayM"];
        continue;
      case "5":
        _0x2baf30[_0x5d94b7(214)] = _0x2ce1c9["BJSgp"];
        continue;
      case "6":
        _0x2baf30[_0x2ce1c9["JEuAN"]] = _0x2ce1c9[_0x5d94b7(193)];
        continue;
      case "7":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(154)]] = _0x2ce1c9["VrGay"];
        continue;
      case "8":
        _0x2baf30[_0x2ce1c9["SyQCB"]] = _0x2ce1c9[_0x5d94b7(188)];
        continue;
      case "9":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(213)]] = _0x5d94b7(173);
        continue;
      case "10":
        _0x2baf30[_0x5d94b7(200)] = _0x5d94b7(186);
        continue;
      case "11":
        _0x2baf30[_0x5d94b7(189)] = _0x2ce1c9[_0x5d94b7(183)];
        continue;
      case "12":
        _0x2baf30[_0x5d94b7(224)] = _0x2ce1c9[_0x5d94b7(205)];
        continue;
      case "13":
        _0x2baf30[_0x5d94b7(197)] = _0x2ce1c9[_0x5d94b7(160)];
        continue;
      case "14":
        _0x2baf30[_0x5d94b7(165)] = _0x5d94b7(178);
        continue;
      case "15":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(207)]] = _0x5d94b7(176);
        continue;
      case "16":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(187)]] = _0x2ce1c9["oaaGh"];
        continue;
      case "17":
        _0x2baf30[_0x2ce1c9["ghLgm"]] = _0x5d94b7(206);
        continue;
      case "18":
        return _0x2baf30;
      case "19":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(208)]] = _0x2ce1c9[_0x5d94b7(203)];
        continue;
      case "20":
        _0x2baf30[_0x2ce1c9[_0x5d94b7(170)]] = _0x2ce1c9[_0x5d94b7(182)];
        continue;
      case "21":
        _0x2baf30[_0x2ce1c9["RJXSH"]] = _0x2ce1c9[_0x5d94b7(181)];
        continue;
      case "22":
        _0x2baf30[_0x5d94b7(177)] = _0x2ce1c9["BsMJa"];
        continue;
    }
    break;
  }
})(Events || {});
function _0x4dfc() {
  const _0x19c0d2 = ["372CMQAPY", " listener", "CONNECTION_RESTORING_ERROR", "sdkScope", "detail", "42ofitnj", "15365BaNGpY", "51653QUvvPX", "ton-connect-ui-", "TRANSACTION_SIGNING_FAILED", "WALLET_CONNECT_ERROR", "tonConnectUiEvents", "TRANSACTION_SENT_FOR_SIGNATURE", "log", "10nskGIt", "CONNECTION_RESTORING_SUCCESS", "analyticsController", "ton-connect-", "126cchdpK", "map", "Attach ", "GbMEX", "WALLET_CONNECT_STARTED", "CUSTOM_EVENT", "11IAkcMU", "LPCSL", "576336bMweOx", "event ", "split", "AaQeD", "4269811ZkoGkJ", "488736LDhUWK", "TRANSACTION_SIGNED", "WALLET_CONNECT_SUCCESS", "events", "440IsKtrJ", "tonConnectSdkEvents", "type", "0|3|4|2|1", "12xnlELH", "LLpLF", "5243FxXRKO", "uiScope", "4127139EgwGkF", "collectEvent"];
  _0x4dfc = function() {
    return _0x19c0d2;
  };
  return _0x4dfc();
}
const _0x5d4311 = _0x6d4a;
(function(_0x20ff29, _0x4631e3) {
  const _0x41bc24 = _0x6d4a, _0x1d0a7c = _0x20ff29();
  while (!![]) {
    try {
      const _0x2d640f = parseInt(_0x41bc24(205)) / 1 * (-parseInt(_0x41bc24(227)) / 2) + -parseInt(_0x41bc24(195)) / 3 * (parseInt(_0x41bc24(203)) / 4) + -parseInt(_0x41bc24(215)) / 5 * (-parseInt(_0x41bc24(209)) / 6) + -parseInt(_0x41bc24(216)) / 7 * (-parseInt(_0x41bc24(199)) / 8) + parseInt(_0x41bc24(207)) / 9 * (-parseInt(_0x41bc24(223)) / 10) + -parseInt(_0x41bc24(188)) / 11 * (parseInt(_0x41bc24(190)) / 12) + parseInt(_0x41bc24(194)) / 13 * (parseInt(_0x41bc24(214)) / 14);
      if (_0x2d640f === _0x4631e3) break;
      else _0x1d0a7c["push"](_0x1d0a7c["shift"]());
    } catch (_0x149df8) {
      _0x1d0a7c["push"](_0x1d0a7c["shift"]());
    }
  }
})(_0x4dfc, 256068);
function _0x6d4a(_0x374785, _0x50d8e0) {
  const _0x4dfcd5 = _0x4dfc();
  return _0x6d4a = function(_0x6d4a53, _0x1272a7) {
    _0x6d4a53 = _0x6d4a53 - 186;
    let _0x14df0e = _0x4dfcd5[_0x6d4a53];
    return _0x14df0e;
  }, _0x6d4a(_0x374785, _0x50d8e0);
}
class TonConnectObserver {
  constructor(_0x22fa0e) {
    const _0x1c2ef8 = _0x6d4a, _0x2836cb = { "LPCSL": _0x1c2ef8(226), "AaQeD": _0x1c2ef8(217) }, _0x49c1ab = _0x1c2ef8(202)[_0x1c2ef8(192)]("|");
    let _0x2ab871 = 0;
    while (!![]) {
      switch (_0x49c1ab[_0x2ab871++]) {
        case "0":
          this[_0x1c2ef8(200)] = [Events[_0x1c2ef8(187)], Events[_0x1c2ef8(197)], Events[_0x1c2ef8(219)], Events["CONNECTION_RESTORING_SUCCESS"], Events[_0x1c2ef8(211)], Events[_0x1c2ef8(221)], Events[_0x1c2ef8(196)], Events[_0x1c2ef8(218)], Events["WALLET_DISCONNECT"]];
          continue;
        case "1":
          this[_0x1c2ef8(225)] = _0x22fa0e;
          continue;
        case "2":
          this[_0x1c2ef8(212)] = _0x2836cb[_0x1c2ef8(189)];
          continue;
        case "3":
          this[_0x1c2ef8(220)] = [Events[_0x1c2ef8(186)], Events[_0x1c2ef8(219)], Events[_0x1c2ef8(218)]];
          continue;
        case "4":
          this["uiScope"] = _0x2836cb[_0x1c2ef8(193)];
          continue;
      }
      break;
    }
  }
  ["init"]() {
    const _0x12f369 = _0x6d4a, _0x5e56c8 = { "GHTwK": "ton-connect-ui-", "UNhUX": _0x12f369(226), "LLpLF": "GbMEX" };
    for (let _0x1fb271 of this[_0x12f369(198)]) {
      _0x12f369(230) !== _0x5e56c8[_0x12f369(204)] ? (this[_0x12f369(200)] = [_0x1689dd[_0x12f369(187)], _0x27d9ec["WALLET_CONNECT_SUCCESS"], _0x3290e8[_0x12f369(219)], _0xe187d1[_0x12f369(224)], _0x301693[_0x12f369(211)], _0x37d848[_0x12f369(221)], _0x870573["TRANSACTION_SIGNED"], _0x41f5d4[_0x12f369(218)], _0x4301cf["WALLET_DISCONNECT"]], this[_0x12f369(220)] = [_0x7f6356[_0x12f369(186)], _0x3249e9[_0x12f369(219)], _0x46e30a[_0x12f369(218)]], this[_0x12f369(206)] = _0x5e56c8["GHTwK"], this[_0x12f369(212)] = _0x5e56c8["UNhUX"], this[_0x12f369(225)] = _0x2bd4c9) : (console[_0x12f369(222)](_0x12f369(229) + _0x1fb271 + _0x12f369(210)), window["addEventListener"](_0x1fb271, (_0x35ba0e) => {
        const _0x105f95 = _0x12f369;
        console[_0x105f95(222)](_0x105f95(191) + _0x1fb271 + " received", _0x35ba0e[_0x105f95(213)]);
        const { type: _0x31f46e, ..._0x482907 } = _0x35ba0e[_0x105f95(213)];
        this[_0x105f95(225)][_0x105f95(208)](_0x35ba0e[_0x105f95(213)][_0x105f95(201)], { ..._0x482907 });
      }));
    }
  }
  get [_0x5d4311(198)]() {
    const _0x55c1e3 = _0x5d4311, _0x26079e = this["tonConnectUiEvents"][_0x55c1e3(228)]((_0x4fef55) => "" + this[_0x55c1e3(206)] + _0x4fef55), _0x2bcc4c = this["tonConnectSdkEvents"][_0x55c1e3(228)]((_0x4c8118) => "" + this[_0x55c1e3(212)] + _0x4c8118);
    return [..._0x26079e, ..._0x2bcc4c];
  }
}
function _0x5de7(_0x32a2ca, _0x230734) {
  const _0x4dca93 = _0x4dca();
  return _0x5de7 = function(_0x5de7b6, _0x16b596) {
    _0x5de7b6 = _0x5de7b6 - 256;
    let _0x165571 = _0x4dca93[_0x5de7b6];
    return _0x165571;
  }, _0x5de7(_0x32a2ca, _0x230734);
}
function _0x4dca() {
  const _0x48fc30 = ["hidden", "pDyUu", "17506179TbpFgT", "analyticsController", "weouh", "954234pjYBeh", "entries", "visibilityState", "1801539pKUhPU", "init", "113266OBSISQ", "1265390QxnOdJ", "4mKwYLM", "8OAxVcK", "collectEvent", "documentEvents", "FswlV", "addEventListener", "4143330AwxLbL", "BnjkR", "zPrmJ", "HIDE", "4498788wSCSTd"];
  _0x4dca = function() {
    return _0x48fc30;
  };
  return _0x4dca();
}
const _0x584641 = _0x5de7;
(function(_0x1401a6, _0x185277) {
  const _0x559818 = _0x5de7, _0x13aa48 = _0x1401a6();
  while (!![]) {
    try {
      const _0x3b9b97 = -parseInt(_0x559818(259)) / 1 + -parseInt(_0x559818(277)) / 2 + -parseInt(_0x559818(257)) / 3 + parseInt(_0x559818(261)) / 4 * (-parseInt(_0x559818(260)) / 5) + parseInt(_0x559818(267)) / 6 + -parseInt(_0x559818(271)) / 7 + -parseInt(_0x559818(262)) / 8 * (-parseInt(_0x559818(274)) / 9);
      if (_0x3b9b97 === _0x185277) break;
      else _0x13aa48["push"](_0x13aa48["shift"]());
    } catch (_0x5188eb) {
      _0x13aa48["push"](_0x13aa48["shift"]());
    }
  }
})(_0x4dca, 549028);
class DocumentObserver {
  constructor(_0x2ac5a0) {
    const _0x528e33 = _0x5de7, _0x44eaf4 = { "weouh": function(_0x1836e0, _0x2feede) {
      return _0x1836e0 === _0x2feede;
    } };
    this[_0x528e33(264)] = { "visibilitychange": () => {
      const _0x302823 = _0x528e33;
      _0x44eaf4[_0x302823(276)](document[_0x302823(256)], _0x302823(272)) && this[_0x302823(275)][_0x302823(263)](Events[_0x302823(270)], void 0);
    } }, this["analyticsController"] = _0x2ac5a0;
  }
  [_0x584641(258)]() {
    const _0x453ee0 = _0x584641, _0x28e701 = { "FswlV": function(_0x1fe001, _0x260d02) {
      return _0x1fe001 === _0x260d02;
    }, "pDyUu": _0x453ee0(269) };
    for (let [_0x789412, _0x3b67e5] of Object[_0x453ee0(278)](this[_0x453ee0(264)])) {
      _0x28e701[_0x453ee0(265)](_0x453ee0(268), _0x28e701[_0x453ee0(273)]) ? (this[_0x453ee0(264)] = { "visibilitychange": () => {
        const _0x3a98ef = _0x453ee0;
        _0x3018d9[_0x3a98ef(256)] === _0x3a98ef(272) && this[_0x3a98ef(275)][_0x3a98ef(263)](_0x16a5f9[_0x3a98ef(270)], void 0);
      } }, this[_0x453ee0(275)] = _0x245832) : document[_0x453ee0(266)](_0x789412, _0x3b67e5);
    }
  }
}
const _0x394399 = _0x1574;
(function(_0x3a633b, _0x419847) {
  const _0x4b1d93 = _0x1574, _0x26ce53 = _0x3a633b();
  while (!![]) {
    try {
      const _0x18d996 = -parseInt(_0x4b1d93(140)) / 1 * (parseInt(_0x4b1d93(135)) / 2) + parseInt(_0x4b1d93(143)) / 3 + parseInt(_0x4b1d93(149)) / 4 + parseInt(_0x4b1d93(151)) / 5 * (-parseInt(_0x4b1d93(144)) / 6) + -parseInt(_0x4b1d93(129)) / 7 + parseInt(_0x4b1d93(150)) / 8 * (-parseInt(_0x4b1d93(148)) / 9) + parseInt(_0x4b1d93(134)) / 10 * (parseInt(_0x4b1d93(142)) / 11);
      if (_0x18d996 === _0x419847) break;
      else _0x26ce53["push"](_0x26ce53["shift"]());
    } catch (_0x30bfa4) {
      _0x26ce53["push"](_0x26ce53["shift"]());
    }
  }
})(_0x3dbb, 388439);
function _0x3dbb() {
  const _0x7ae242 = [" received", "193761JrusNY", "648976yyhlQC", "136UGrVsF", "90LadFcz", "3298890NcydfF", "ADDITIONAL_TASK_EVENT", "telegramAppsCenterEvents", "init", "event ", "12636700TRIHGG", "12nXhhBp", "collectTappsEvent", "addEventListener", "analyticsController", "detail", "17378HGzgkS", "Attach ", "11NuZySC", "617424zjlDWo", "100584ZayRYt", "log", " listener"];
  _0x3dbb = function() {
    return _0x7ae242;
  };
  return _0x3dbb();
}
function _0x1574(_0x5dca42, _0x48fc09) {
  const _0x3dbbe1 = _0x3dbb();
  return _0x1574 = function(_0x15749a, _0x8bf81e) {
    _0x15749a = _0x15749a - 129;
    let _0x2586fe = _0x3dbbe1[_0x15749a];
    return _0x2586fe;
  }, _0x1574(_0x5dca42, _0x48fc09);
}
class TappsObserver {
  constructor(_0xda7d55) {
    const _0x97499a = _0x1574;
    this["telegramAppsCenterEvents"] = [Events[_0x97499a(130)]], this[_0x97499a(138)] = _0xda7d55;
  }
  [_0x394399(132)]() {
    const _0x898a62 = _0x394399;
    for (let _0x9ee76c of this[_0x898a62(131)]) {
      console[_0x898a62(145)](_0x898a62(141) + _0x9ee76c + _0x898a62(146)), window[_0x898a62(137)](_0x9ee76c, (_0x21126b) => {
        const _0x29b663 = _0x898a62;
        console[_0x29b663(145)](_0x29b663(133) + _0x9ee76c + _0x29b663(147), _0x21126b[_0x29b663(139)]);
        const { type: _0x35c7e7, ..._0x4e68dc } = _0x21126b[_0x29b663(139)];
        this[_0x29b663(138)][_0x29b663(136)](_0x21126b[_0x29b663(139)]["type"], { ..._0x4e68dc });
      });
    }
  }
}
const _0x1e3b50 = _0x2d20;
function _0x1d5e() {
  const _0x8b5b4c = ["call", "bKFnE", "analyticsController", "4EylsBs", "1898358fCzawN", "66904bcFKZb", "699845ymENUU", "453100SvBzaD", "1676440BbjhBm", "276369dUhOfs", "init", "WebApp", "pop", "openInvoice", "9vvXtmU", "6ifROat", "webApp", "PURCHASE_INIT", "118487FDoDwR"];
  _0x1d5e = function() {
    return _0x8b5b4c;
  };
  return _0x1d5e();
}
function _0x2d20(_0x25673a, _0x46f88a) {
  const _0x1d5eb6 = _0x1d5e();
  return _0x2d20 = function(_0x2d2095, _0xfd472e) {
    _0x2d2095 = _0x2d2095 - 122;
    let _0x9ef6cf = _0x1d5eb6[_0x2d2095];
    return _0x9ef6cf;
  }, _0x2d20(_0x25673a, _0x46f88a);
}
(function(_0x18f6b5, _0x2f4f2e) {
  const _0x4f9f48 = _0x2d20, _0x5d5bfa = _0x18f6b5();
  while (!![]) {
    try {
      const _0x41876c = -parseInt(_0x4f9f48(128)) / 1 + -parseInt(_0x4f9f48(132)) / 2 * (parseInt(_0x4f9f48(138)) / 3) + -parseInt(_0x4f9f48(136)) / 4 + parseInt(_0x4f9f48(135)) / 5 * (parseInt(_0x4f9f48(125)) / 6) + parseInt(_0x4f9f48(133)) / 7 + parseInt(_0x4f9f48(134)) / 8 * (parseInt(_0x4f9f48(124)) / 9) + parseInt(_0x4f9f48(137)) / 10;
      if (_0x41876c === _0x2f4f2e) break;
      else _0x5d5bfa["push"](_0x5d5bfa["shift"]());
    } catch (_0x2929b) {
      _0x5d5bfa["push"](_0x5d5bfa["shift"]());
    }
  }
})(_0x1d5e, 171162);
class WebAppObserver {
  constructor(_0x25e117) {
    var _a;
    const _0x557cc9 = _0x2d20, _0x170e95 = { "bKFnE": function(_0x210048, _0x398d75) {
      return _0x210048 !== _0x398d75;
    } };
    this[_0x557cc9(126)] = _0x170e95[_0x557cc9(130)](typeof window, "undefined") && ((_a = window == null ? void 0 : window["Telegram"]) == null ? void 0 : _a[_0x557cc9(140)]) ? window["Telegram"]["WebApp"] : null, this["analyticsController"] = _0x25e117;
  }
  [_0x1e3b50(139)]() {
    const _0x53f4b0 = _0x1e3b50;
    if (this[_0x53f4b0(126)]) {
      const _0x57354f = this[_0x53f4b0(126)][_0x53f4b0(123)];
      this[_0x53f4b0(126)][_0x53f4b0(123)] = (_0x2578d1, _0x1755ce) => {
        const _0x1f16fc = _0x53f4b0, _0x70cfc0 = _0x2578d1["split"]("/")[_0x1f16fc(122)]() || "";
        return this[_0x1f16fc(131)]["collectEvent"](Events[_0x1f16fc(127)], { "slug": _0x70cfc0 }), _0x57354f[_0x1f16fc(129)](this[_0x1f16fc(126)], _0x2578d1, _0x1755ce);
      };
    }
  }
}
var _0x450cb0 = _0xc34e;
function _0xc34e(_0x2cecf2, _0x394800) {
  var _0xd5126e = _0xd512();
  return _0xc34e = function(_0xc34ea5, _0x3bbc00) {
    _0xc34ea5 = _0xc34ea5 - 420;
    var _0x2c9ec7 = _0xd5126e[_0xc34ea5];
    return _0x2c9ec7;
  }, _0xc34e(_0x2cecf2, _0x394800);
}
(function(_0x2d1dfb, _0xc0175f) {
  var _0x42bc28 = _0xc34e, _0x285b28 = _0x2d1dfb();
  while (!![]) {
    try {
      var _0x54b9e3 = -parseInt(_0x42bc28(442)) / 1 + -parseInt(_0x42bc28(444)) / 2 + -parseInt(_0x42bc28(435)) / 3 * (parseInt(_0x42bc28(426)) / 4) + -parseInt(_0x42bc28(439)) / 5 * (-parseInt(_0x42bc28(443)) / 6) + parseInt(_0x42bc28(431)) / 7 * (parseInt(_0x42bc28(428)) / 8) + parseInt(_0x42bc28(437)) / 9 + parseInt(_0x42bc28(440)) / 10;
      if (_0x54b9e3 === _0xc0175f) break;
      else _0x285b28["push"](_0x285b28["shift"]());
    } catch (_0x5a48f5) {
      _0x285b28["push"](_0x285b28["shift"]());
    }
  }
})(_0xd512, 308341);
class WebViewObserver {
  constructor(_0x2597d8) {
    var _a;
    var _0x1a1218 = _0xc34e, _0x2640fa = { "lPCNI": _0x1a1218(422) };
    this["webView"] = typeof window !== _0x2640fa[_0x1a1218(425)] && ((_a = window == null ? void 0 : window["Telegram"]) == null ? void 0 : _a[_0x1a1218(445)]) ? window["Telegram"]["WebView"] : null, this[_0x1a1218(433)] = { "paid": Events["PURCHASE_SUCCESS"], "cancelled": Events[_0x1a1218(421)], "failed": Events[_0x1a1218(421)] }, this["analyticsController"] = _0x2597d8;
  }
  [_0x450cb0(436)]() {
    var _a;
    var _0x477159 = _0x450cb0, _0x3062a4 = { "QKSvv": function(_0x35d244, _0xe08f1c) {
      return _0x35d244 === _0xe08f1c;
    }, "njLGY": "SvmwI", "zCXQB": _0x477159(423) };
    this[_0x477159(429)] && ((_a = this[_0x477159(429)]) == null ? void 0 : _a[_0x477159(441)](_0x3062a4[_0x477159(434)], (_0x4dda74, _0x8aa405) => {
      var _a2;
      var _0x47d484 = _0x477159;
      _0x3062a4[_0x47d484(424)](_0x3062a4[_0x47d484(438)], _0x47d484(420)) ? this[_0x47d484(429)] && ((_a2 = this[_0x47d484(429)]) == null ? void 0 : _a2[_0x47d484(441)](_0x47d484(423), (_0x4ba2be, _0x338b3c) => {
        var _0x28712d = _0x47d484;
        this[_0x28712d(433)][_0x338b3c[_0x28712d(446)]] && this[_0x28712d(427)][_0x28712d(430)](this["eventStatusMap"][_0x338b3c[_0x28712d(446)]], { "slug": _0x338b3c[_0x28712d(432)] });
      })) : this[_0x47d484(433)][_0x8aa405[_0x47d484(446)]] && this["analyticsController"][_0x47d484(430)](this[_0x47d484(433)][_0x8aa405[_0x47d484(446)]], { "slug": _0x8aa405[_0x47d484(432)] });
    }));
  }
}
function _0xd512() {
  var _0x495de0 = ["15522ouxQKI", "init", "1401408zxLnxp", "njLGY", "1223020Bcmmig", "7383450spgVQZ", "onEvent", "467640WJKnKn", "6ckXyjF", "406246XcBzsg", "WebView", "status", "KaQoJ", "PURCHASE_FAILED", "undefined", "invoice_closed", "QKSvv", "lPCNI", "424aWdcaT", "analyticsController", "24fjrWOr", "webView", "collectEvent", "907403HeHehn", "slug", "eventStatusMap", "zCXQB"];
  _0xd512 = function() {
    return _0x495de0;
  };
  return _0xd512();
}
var _0x164789 = _0x5d75;
(function(_0x1f36ca, _0x4304c9) {
  var _0x5c6f2b = _0x5d75, _0x574b02 = _0x1f36ca();
  while (!![]) {
    try {
      var _0x125e74 = parseInt(_0x5c6f2b(253)) / 1 + parseInt(_0x5c6f2b(243)) / 2 * (-parseInt(_0x5c6f2b(268)) / 3) + parseInt(_0x5c6f2b(262)) / 4 * (parseInt(_0x5c6f2b(264)) / 5) + parseInt(_0x5c6f2b(258)) / 6 + -parseInt(_0x5c6f2b(256)) / 7 * (parseInt(_0x5c6f2b(237)) / 8) + parseInt(_0x5c6f2b(250)) / 9 + -parseInt(_0x5c6f2b(248)) / 10;
      if (_0x125e74 === _0x4304c9) break;
      else _0x574b02["push"](_0x574b02["shift"]());
    } catch (_0x573715) {
      _0x574b02["push"](_0x574b02["shift"]());
    }
  }
})(_0x2688, 849053);
function _0x2688() {
  var _0x5d328d = ["appModule", "VXEXo", "172496lRVHFK", "error", "SjYfO", "28MGeAww", "catch", "7579404WBmefR", "recordEvent", "collectTappsEvent", "qbSXr", "22588cdfYcP", "env", "925uVMHmj", "timeout", "init", "dcLNs", "3693uDXkPs", "bDxVH", "events/threshold", "XOpzK", "webViewObserver", "AXmiO", "webAppObserver", "tonConnectObserver", "824896fDXsvZ", "documentObserver", "STG", "eventsThreshold", "tappsObserver", "FtKvo", "938MlrzWm", "GBITv", "zsvTa", "collectEvent", "split", "21199860rErZlb", "json", "13305609VvEnMg"];
  _0x2688 = function() {
    return _0x5d328d;
  };
  return _0x2688();
}
function _0x5d75(_0x45056a, _0x58ed20) {
  var _0x2688d1 = _0x2688();
  return _0x5d75 = function(_0x5d7585, _0x4370d0) {
    _0x5d7585 = _0x5d7585 - 231;
    var _0x3dc8be = _0x2688d1[_0x5d7585];
    return _0x3dc8be;
  }, _0x5d75(_0x45056a, _0x58ed20);
}
class AnalyticsController {
  constructor(_0x148fee) {
    var _0x10227e = _0x5d75, _0x280437 = "2|5|4|3|0|1"[_0x10227e(247)]("|"), _0x435f69 = 0;
    while (!![]) {
      switch (_0x280437[_0x435f69++]) {
        case "0":
          this[_0x10227e(233)] = new WebViewObserver(this);
          continue;
        case "1":
          this[_0x10227e(241)] = new TappsObserver(this);
          continue;
        case "2":
          this[_0x10227e(251)] = _0x148fee;
          continue;
        case "3":
          this["webAppObserver"] = new WebAppObserver(this);
          continue;
        case "4":
          this[_0x10227e(236)] = new TonConnectObserver(this);
          continue;
        case "5":
          this[_0x10227e(238)] = new DocumentObserver(this);
          continue;
      }
      break;
    }
  }
  async ["init"]() {
    var _0x1e5f15 = _0x5d75, _0x3bb888 = { "XOpzK": function(_0x85e271, _0x246e12) {
      return _0x85e271 === _0x246e12;
    }, "bDxVH": "BgKfd", "omvpp": function(_0x279187, _0x406215, _0x411e4f) {
      return _0x279187(_0x406215, _0x411e4f);
    }, "VXEXo": _0x1e5f15(239), "dcLNs": _0x1e5f15(231), "GBITv": "OxFYQ" };
    this["documentObserver"]["init"](), this[_0x1e5f15(236)][_0x1e5f15(266)](), this["webAppObserver"][_0x1e5f15(266)](), this[_0x1e5f15(233)][_0x1e5f15(266)](), this["tappsObserver"][_0x1e5f15(266)]();
    try {
      _0x3bb888[_0x1e5f15(269)] === _0x3bb888[_0x1e5f15(269)] ? this[_0x1e5f15(240)] = await (await _0x3bb888["omvpp"](fetch, (_0x3bb888[_0x1e5f15(232)](this[_0x1e5f15(251)][_0x1e5f15(263)], _0x3bb888[_0x1e5f15(252)]) ? STAGING_BACKEND_URL : BACKEND_URL) + _0x3bb888[_0x1e5f15(267)], { "signal": AbortSignal[_0x1e5f15(265)](2e3) }))[_0x1e5f15(249)]() : (this[_0x1e5f15(251)] = _0x2f8552, this[_0x1e5f15(238)] = new _0x7a0daf(this), this["tonConnectObserver"] = new _0x37d799(this), this[_0x1e5f15(235)] = new _0x568755(this), this[_0x1e5f15(233)] = new _0x2e6f7b(this), this[_0x1e5f15(241)] = new _0x267c8a(this));
    } catch (_0x57325f) {
      if (_0x3bb888[_0x1e5f15(232)](_0x3bb888[_0x1e5f15(244)], _0x1e5f15(234))) {
        if (_0x3bb888[_0x1e5f15(232)](this[_0x1e5f15(240)][_0xfe43db], 0)) return;
        this[_0x1e5f15(251)][_0x1e5f15(246)](_0x4e48d5, _0x144277), this[_0x1e5f15(240)][_0x371755] && this[_0x1e5f15(240)][_0x3a50b3]--;
      } else this["eventsThreshold"] = { "app-hide": 3 };
    }
  }
  ["recordEvent"](_0x5afa98, _0x28ee58) {
    var _0xd13eec = _0x5d75;
    this[_0xd13eec(251)][_0xd13eec(259)](_0x5afa98, _0x28ee58)[_0xd13eec(257)]((_0x1156c8) => console[_0xd13eec(254)](_0x1156c8));
  }
  [_0x164789(246)](_0x544785, _0x4971b1) {
    var _0x3208bf = _0x164789, _0x4871ea = { "bIaSB": function(_0x3690d2, _0x1c4f36) {
      return _0x3690d2 === _0x1c4f36;
    }, "SjYfO": function(_0x1beece, _0x222521) {
      return _0x1beece === _0x222521;
    }, "qbSXr": _0x3208bf(245) };
    if (_0x4871ea["bIaSB"](this[_0x3208bf(240)][_0x544785], 0)) return;
    this["appModule"][_0x3208bf(246)](_0x544785, _0x4971b1), this[_0x3208bf(240)][_0x544785] && (_0x4871ea[_0x3208bf(255)](_0x4871ea[_0x3208bf(261)], _0x3208bf(242)) ? this[_0x3208bf(240)] = { "app-hide": 3 } : this[_0x3208bf(240)][_0x544785]--);
  }
  [_0x164789(260)](_0x22dbb1, _0x5401da) {
    var _0x11fc27 = _0x164789;
    this[_0x11fc27(251)][_0x11fc27(260)](_0x22dbb1, _0x5401da);
  }
}
(function(_0x1b8efc, _0x2657cb) {
  const _0x3ed1c8 = _0x5f2c, _0x2c7827 = _0x1b8efc();
  while (!![]) {
    try {
      const _0x29a9f2 = parseInt(_0x3ed1c8(278)) / 1 + parseInt(_0x3ed1c8(269)) / 2 + parseInt(_0x3ed1c8(265)) / 3 * (-parseInt(_0x3ed1c8(272)) / 4) + parseInt(_0x3ed1c8(273)) / 5 + -parseInt(_0x3ed1c8(267)) / 6 * (-parseInt(_0x3ed1c8(274)) / 7) + -parseInt(_0x3ed1c8(275)) / 8 + parseInt(_0x3ed1c8(270)) / 9;
      if (_0x29a9f2 === _0x2657cb) break;
      else _0x2c7827["push"](_0x2c7827["shift"]());
    } catch (_0x4652fc) {
      _0x2c7827["push"](_0x2c7827["shift"]());
    }
  }
})(_0x4fd5, 243617);
const throwError = (_0x1a1e15) => {
  throw new Error(_0x1a1e15);
};
function _0x5f2c(_0x2ce45f, _0x1e2f52) {
  const _0x4fd5a9 = _0x4fd5();
  return _0x5f2c = function(_0x5f2c79, _0x443696) {
    _0x5f2c79 = _0x5f2c79 - 264;
    let _0x277587 = _0x4fd5a9[_0x5f2c79];
    return _0x277587;
  }, _0x5f2c(_0x2ce45f, _0x1e2f52);
}
function _0x4fd5() {
  const _0x2f115c = ["afRhk", "12SIoqap", "USER_DATA_IS_NOT_PROVIDED", "354174SXJhuO", "2680281MpFVdH", "IYjIx", "264452jsJsoi", "60870gwlfjI", "76986SrJxZl", "677368sTkKVQ", "tbkjZ", "TOKEN_IS_NOT_PROVIDED", "282013ZxoXbn", "MwhoT", "21iyDvPb"];
  _0x4fd5 = function() {
    return _0x2f115c;
  };
  return _0x4fd5();
}
var Errors = ((_0x1d20c4) => {
  const _0x48d859 = _0x5f2c, _0x5c3b85 = { "MwhoT": _0x48d859(277), "afRhk": "Token is not provided.", "IYjIx": _0x48d859(268), "tbkjZ": "Telegram User data is not provided." };
  return _0x1d20c4[_0x5c3b85[_0x48d859(264)]] = _0x5c3b85[_0x48d859(266)], _0x1d20c4[_0x5c3b85[_0x48d859(271)]] = _0x5c3b85[_0x48d859(276)], _0x1d20c4;
})(Errors || {});
function _0x4cad() {
  const _0x350323 = ["QgNNX", "env", "status", "qcuuw", "13810nLDoAL", "BACKEND_URL", "dbopL", "6llJhfM", "application/json", "POST", "SNyBG", "appModule", "recordEvent", "events", "VpxIE", "then", "UbuRg", "36huIHhW", "JefFB", "kinOI", "Content", "55QFyYTe", "phpTq", "JoOPe", "taskSolution", "cLNnB", "6710556GzQsLO", "360873wSAluj", "custom_data", "QOiFT", "XnVFB", "PBFHY", "5886ACmOqG", "pDPHI", "json", "assign", "503531kGLuVq", "setNewArgs", "93dSUKJF", "getApiToken", "iOCnb", "generateHeaders", "8351144iwBotm", "responseToParams", "stringify", "ujEcH", "STG", "46868ZoxXaC", "PONyl", "TOKEN_IS_NOT_PROVIDED", "ykcxg", "HoEsj", "init", "8525115ldTFyz"];
  _0x4cad = function() {
    return _0x350323;
  };
  return _0x4cad();
}
function _0x129f(_0x4c4d3f, _0x351543) {
  const _0x4cad47 = _0x4cad();
  return _0x129f = function(_0x129f5e, _0x4da200) {
    _0x129f5e = _0x129f5e - 473;
    let _0x1b1fce = _0x4cad47[_0x129f5e];
    return _0x1b1fce;
  }, _0x129f(_0x4c4d3f, _0x351543);
}
const _0x40aa1b = _0x129f;
(function(_0x20810c, _0x407b1c) {
  const _0x29c70d = _0x129f, _0x569a36 = _0x20810c();
  while (!![]) {
    try {
      const _0x119647 = parseInt(_0x29c70d(523)) / 1 * (-parseInt(_0x29c70d(503)) / 2) + -parseInt(_0x29c70d(480)) / 3 * (-parseInt(_0x29c70d(489)) / 4) + -parseInt(_0x29c70d(495)) / 5 + -parseInt(_0x29c70d(513)) / 6 * (-parseInt(_0x29c70d(478)) / 7) + parseInt(_0x29c70d(484)) / 8 + -parseInt(_0x29c70d(474)) / 9 * (parseInt(_0x29c70d(500)) / 10) + parseInt(_0x29c70d(517)) / 11 * (parseInt(_0x29c70d(522)) / 12);
      if (_0x119647 === _0x407b1c) break;
      else _0x569a36["push"](_0x569a36["shift"]());
    } catch (_0x3add99) {
      _0x569a36["push"](_0x569a36["shift"]());
    }
  }
})(_0x4cad, 943967);
class NetworkController {
  constructor(_0x48bac) {
    const _0x88d36e = _0x129f, _0x29a97a = { "HoEsj": function(_0x499f22, _0x230139) {
      return _0x499f22 === _0x230139;
    }, "ujEcH": _0x88d36e(518), "XnVFB": function(_0x1bb530, _0x4b8a08) {
      return _0x1bb530(_0x4b8a08);
    }, "PONyl": _0x88d36e(519), "JefFB": function(_0x11f819, _0x7d6dbb) {
      return _0x11f819 === _0x7d6dbb;
    }, "UbuRg": _0x88d36e(488), "iOCnb": function(_0x1d839f, _0xc50429) {
      return _0x1d839f(_0xc50429);
    } };
    this[_0x88d36e(501)] = BACKEND_URL, this["responseToParams"] = async (_0x18d9dc) => {
      const _0x3405f9 = _0x88d36e;
      if (_0x29a97a[_0x3405f9(493)](_0x29a97a["ujEcH"], _0x29a97a[_0x3405f9(487)])) {
        const _0x404121 = _0x18d9dc["clone"]();
        if (_0x29a97a[_0x3405f9(493)](_0x29a97a[_0x3405f9(526)](String, _0x404121[_0x3405f9(498)])[0], "2") || _0x29a97a[_0x3405f9(493)](_0x404121[_0x3405f9(498)], 429)) {
          const _0x4d5372 = await _0x404121[_0x3405f9(476)]();
          this[_0x3405f9(507)][_0x3405f9(479)](_0x4d5372[_0x3405f9(516)]);
        }
        return _0x18d9dc;
      } else !_0x2ffe56 ? _0x19f07f = _0x34eeaa[_0x3405f9(524)] : _0x42b9d6 = _0x41515b[_0x3405f9(477)](_0x2895b0[_0x3405f9(524)], _0x1b82ab);
    }, this[_0x88d36e(483)] = () => {
      const _0x45f34f = _0x88d36e;
      if (_0x29a97a[_0x45f34f(490)] === _0x29a97a[_0x45f34f(490)]) {
        this[_0x45f34f(507)]["solveTask"]();
        if (this[_0x45f34f(507)][_0x45f34f(520)]) return { "TGA-Auth-Token": this[_0x45f34f(507)][_0x45f34f(481)](), "Content-Type": _0x45f34f(504), "Content": this["appModule"][_0x45f34f(520)] };
        return { "TGA-Auth-Token": this[_0x45f34f(507)][_0x45f34f(481)](), "Content-Type": _0x45f34f(504) };
      } else _0x2334e9 = _0x22373e[_0x45f34f(477)](_0xb6d344["custom_data"], _0x11885f);
    }, this["appModule"] = _0x48bac, _0x29a97a[_0x88d36e(514)](this[_0x88d36e(507)][_0x88d36e(497)], _0x29a97a[_0x88d36e(512)]) && (this[_0x88d36e(501)] = STAGING_BACKEND_URL), !this["appModule"]["getApiToken"]() && _0x29a97a[_0x88d36e(482)](throwError, Errors[_0x88d36e(491)]);
  }
  [_0x40aa1b(494)]() {
  }
  async ["recordEvents"](_0x28be26) {
    const _0x314d38 = _0x40aa1b, _0x438842 = { "pDPHI": function(_0x15e3c4, _0x236dfd, _0x2751d0) {
      return _0x15e3c4(_0x236dfd, _0x2751d0);
    }, "nwOdr": function(_0x4920b9, _0x20974d) {
      return _0x4920b9 + _0x20974d;
    }, "zpEsi": _0x314d38(509), "PBFHY": _0x314d38(505) };
    return await _0x438842[_0x314d38(475)](fetch, _0x438842["nwOdr"](this[_0x314d38(501)], _0x438842["zpEsi"]), { "method": _0x438842[_0x314d38(473)], "headers": this[_0x314d38(483)](), "body": JSON["stringify"](_0x28be26) })[_0x314d38(511)](this[_0x314d38(485)], this[_0x314d38(485)]);
  }
  async [_0x40aa1b(508)](_0x377d79, _0x50e637, _0x46053b) {
    const _0x3ff706 = _0x40aa1b, _0x4b2d3f = { "dbopL": function(_0x425e61, _0x46cc8b) {
      return _0x425e61(_0x46cc8b);
    }, "QOiFT": _0x3ff706(499), "fCide": function(_0xed2033, _0x3cd993) {
      return _0xed2033 === _0x3cd993;
    }, "SNyBG": _0x3ff706(492), "VpxIE": _0x3ff706(521), "TNaFn": function(_0x184b29, _0x47753d, _0x3b192a) {
      return _0x184b29(_0x47753d, _0x3b192a);
    }, "QgNNX": function(_0x15c0b3, _0x1101c7) {
      return _0x15c0b3 + _0x1101c7;
    }, "pUKvg": _0x3ff706(509), "kinOI": _0x3ff706(505) };
    (_0x50e637 == null ? void 0 : _0x50e637["custom_data"]) && (_0x4b2d3f[_0x3ff706(525)] !== _0x4b2d3f[_0x3ff706(525)] ? _0x4b2d3f[_0x3ff706(502)](_0x28285a, _0x1bc289[_0x3ff706(491)]) : !_0x46053b ? _0x46053b = _0x50e637[_0x3ff706(524)] : _0x4b2d3f["fCide"](_0x4b2d3f[_0x3ff706(506)], _0x4b2d3f[_0x3ff706(510)]) ? this["BACKEND_URL"] = _0x345e88 : _0x46053b = Object[_0x3ff706(477)](_0x50e637["custom_data"], _0x46053b)), await _0x4b2d3f["TNaFn"](fetch, _0x4b2d3f[_0x3ff706(496)](this["BACKEND_URL"], _0x4b2d3f["pUKvg"]), { "method": _0x4b2d3f[_0x3ff706(515)], "headers": this["generateHeaders"](), "body": JSON[_0x3ff706(486)]({ ..._0x50e637, "event_name": _0x377d79, "custom_data": _0x46053b, ...this[_0x3ff706(507)]["assembleEventSession"]() }) })[_0x3ff706(511)](this["responseToParams"], this["responseToParams"]);
  }
}
class V extends Error {
  constructor(e, t, n) {
    super(t, { cause: n }), this.type = e, Object.setPrototypeOf(this, V.prototype);
  }
}
function f(s, e, t) {
  return new V(s, e, t);
}
const Ye = "ERR_UNEXPECTED_TYPE", ce = "ERR_PARSE";
function E() {
  return f(Ye, "Value has unexpected type");
}
class D {
  constructor(e, t, n) {
    this.parser = e, this.isOptional = t, this.type = n;
  }
  /**
   * Attempts to parse passed value
   * @param value - value to parse.
   * @throws {SDKError} ERR_PARSE
   * @see ERR_PARSE
   */
  parse(e) {
    if (!(this.isOptional && e === void 0))
      try {
        return this.parser(e);
      } catch (t) {
        throw f(
          ce,
          `Unable to parse value${this.type ? ` as ${this.type}` : ""}`,
          t
        );
      }
  }
  optional() {
    return this.isOptional = true, this;
  }
}
function S(s, e) {
  return () => new D(s, false, e);
}
const b = S((s) => {
  if (typeof s == "boolean")
    return s;
  const e = String(s);
  if (e === "1" || e === "true")
    return true;
  if (e === "0" || e === "false")
    return false;
  throw E();
}, "boolean");
function pe(s, e) {
  const t = {};
  for (const n in s) {
    const r = s[n];
    if (!r)
      continue;
    let i, o;
    if (typeof r == "function" || "parse" in r)
      i = n, o = typeof r == "function" ? r : r.parse.bind(r);
    else {
      const { type: a } = r;
      i = r.from || n, o = typeof a == "function" ? a : a.parse.bind(a);
    }
    try {
      const a = o(e(i));
      a !== void 0 && (t[n] = a);
    } catch (a) {
      throw f(ce, `Unable to parse field "${n}"`, a);
    }
  }
  return t;
}
function he(s) {
  let e = s;
  if (typeof e == "string" && (e = JSON.parse(e)), typeof e != "object" || e === null || Array.isArray(e))
    throw E();
  return e;
}
function g(s, e) {
  return new D((t) => {
    const n = he(t);
    return pe(s, (r) => n[r]);
  }, false, e);
}
const y = S((s) => {
  if (typeof s == "number")
    return s;
  if (typeof s == "string") {
    const e = Number(s);
    if (!Number.isNaN(e))
      return e;
  }
  throw E();
}, "number"), h = S((s) => {
  if (typeof s == "string" || typeof s == "number")
    return s.toString();
  throw E();
}, "string");
({
  custom_method_invoked: g({
    req_id: h(),
    result: (s) => s,
    error: h().optional()
  })
});
function Q(s) {
  return /^#[\da-f]{6}$/i.test(s);
}
function ht(s) {
  return /^#[\da-f]{3}$/i.test(s);
}
function me(s) {
  const e = s.replace(/\s/g, "").toLowerCase();
  if (Q(e))
    return e;
  if (ht(e)) {
    let n = "#";
    for (let r = 0; r < 3; r += 1)
      n += e[1 + r].repeat(2);
    return n;
  }
  const t = e.match(/^rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)$/) || e.match(/^rgba\((\d{1,3}),(\d{1,3}),(\d{1,3}),\d{1,3}\)$/);
  if (!t)
    throw new Error(`Value "${s}" does not satisfy any of known RGB formats.`);
  return t.slice(1).reduce((n, r) => {
    const i = parseInt(r, 10).toString(16);
    return n + (i.length === 1 ? "0" : "") + i;
  }, "#");
}
const Ee = S((s) => s instanceof Date ? s : new Date(y().parse(s) * 1e3), "Date");
function K(s, e) {
  return new D((t) => {
    if (typeof t != "string" && !(t instanceof URLSearchParams))
      throw E();
    const n = typeof t == "string" ? new URLSearchParams(t) : t;
    return pe(s, (r) => {
      const i = n.get(r);
      return i === null ? void 0 : i;
    });
  }, false, e);
}
const dt = g({
  id: y(),
  type: h(),
  title: h(),
  photoUrl: {
    type: h().optional(),
    from: "photo_url"
  },
  username: h().optional()
}, "Chat").optional(), ne = g({
  addedToAttachmentMenu: {
    type: b().optional(),
    from: "added_to_attachment_menu"
  },
  allowsWriteToPm: {
    type: b().optional(),
    from: "allows_write_to_pm"
  },
  firstName: {
    type: h(),
    from: "first_name"
  },
  id: y(),
  isBot: {
    type: b().optional(),
    from: "is_bot"
  },
  isPremium: {
    type: b().optional(),
    from: "is_premium"
  },
  languageCode: {
    type: h().optional(),
    from: "language_code"
  },
  lastName: {
    type: h().optional(),
    from: "last_name"
  },
  photoUrl: {
    type: h().optional(),
    from: "photo_url"
  },
  username: h().optional()
}, "User").optional();
function Se() {
  return K({
    authDate: {
      type: Ee(),
      from: "auth_date"
    },
    canSendAfter: {
      type: y().optional(),
      from: "can_send_after"
    },
    chat: dt,
    chatInstance: {
      type: h().optional(),
      from: "chat_instance"
    },
    chatType: {
      type: h().optional(),
      from: "chat_type"
    },
    hash: h(),
    queryId: {
      type: h().optional(),
      from: "query_id"
    },
    receiver: ne,
    startParam: {
      type: h().optional(),
      from: "start_param"
    },
    user: ne
  }, "InitData");
}
const _t = S((s) => me(h().parse(s)), "rgb");
function ft(s) {
  return s.replace(/_[a-z]/g, (e) => e[1].toUpperCase());
}
function gt(s) {
  return s.replace(/[A-Z]/g, (e) => `_${e.toLowerCase()}`);
}
const Pe = S(
  (s) => {
    const e = _t().optional();
    return Object.entries(he(s)).reduce((t, [n, r]) => (t[ft(n)] = e.parse(r), t), {});
  },
  "ThemeParams"
);
function X(s) {
  return K({
    botInline: {
      type: b().optional(),
      from: "tgWebAppBotInline"
    },
    initData: {
      type: Se().optional(),
      from: "tgWebAppData"
    },
    initDataRaw: {
      type: h().optional(),
      from: "tgWebAppData"
    },
    platform: {
      type: h(),
      from: "tgWebAppPlatform"
    },
    showSettings: {
      type: b().optional(),
      from: "tgWebAppShowSettings"
    },
    startParam: {
      type: h().optional(),
      from: "tgWebAppStartParam"
    },
    themeParams: {
      type: Pe(),
      from: "tgWebAppThemeParams"
    },
    version: {
      type: h(),
      from: "tgWebAppVersion"
    }
  }).parse(s);
}
function xe(s) {
  return X(
    s.replace(/^[^?#]*[?#]/, "").replace(/[?#]/g, "&")
  );
}
function wt() {
  return xe(window.location.href);
}
function Ce() {
  return performance.getEntriesByType("navigation")[0];
}
function bt() {
  const s = Ce();
  if (!s)
    throw new Error("Unable to get first navigation entry.");
  return xe(s.name);
}
function Te(s) {
  return `telegram-apps/${s.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`)}`;
}
function Re(s, e) {
  sessionStorage.setItem(Te(s), JSON.stringify(e));
}
function Ae(s) {
  const e = sessionStorage.getItem(Te(s));
  try {
    return e ? JSON.parse(e) : void 0;
  } catch {
  }
}
function mt() {
  return X(Ae("launchParams") || "");
}
function Ie(s) {
  return JSON.stringify(
    Object.fromEntries(
      Object.entries(s).map(([e, t]) => [gt(e), t])
    )
  );
}
function yt(s) {
  const {
    initDataRaw: e,
    themeParams: t,
    platform: n,
    version: r,
    showSettings: i,
    startParam: o,
    botInline: a
  } = s, p = new URLSearchParams();
  return p.set("tgWebAppPlatform", n), p.set("tgWebAppThemeParams", Ie(t)), p.set("tgWebAppVersion", r), e && p.set("tgWebAppData", e), o && p.set("tgWebAppStartParam", o), typeof i == "boolean" && p.set("tgWebAppShowSettings", i ? "1" : "0"), typeof a == "boolean" && p.set("tgWebAppBotInline", a ? "1" : "0"), p.toString();
}
function qe(s) {
  Re("launchParams", yt(s));
}
function vt() {
  const s = [];
  for (const e of [
    // Try to retrieve launch parameters from the current location. This method can return
    // nothing in case, location was changed, and then the page was reloaded.
    wt,
    // Then, try using the lower level API - window.performance.
    bt,
    // Finally, try to extract launch parameters from the session storage.
    mt
  ])
    try {
      const t = e();
      return qe(t), t;
    } catch (t) {
      s.push(t instanceof Error ? t.message : JSON.stringify(t));
    }
  throw new Error([
    `Unable to retrieve launch parameters from any known source. Perhaps, you have opened your app outside Telegram?
`,
    "📖 Refer to docs for more information:",
    `https://docs.telegram-mini-apps.com/packages/telegram-apps-sdk/environment
`,
    "Collected errors:",
    s.map((e) => `— ${e}`)
  ].join(`
`));
}
function _0x3497(_0x24f700, _0x1854e5) {
  const _0x68ed96 = _0x68ed();
  return _0x3497 = function(_0x34978a, _0xcda8d5) {
    _0x34978a = _0x34978a - 370;
    let _0x21dad2 = _0x68ed96[_0x34978a];
    return _0x21dad2;
  }, _0x3497(_0x24f700, _0x1854e5);
}
(function(_0xd23515, _0xc974e7) {
  const _0x25ea11 = _0x3497, _0x550667 = _0xd23515();
  while (!![]) {
    try {
      const _0x348a8b = parseInt(_0x25ea11(372)) / 1 + -parseInt(_0x25ea11(377)) / 2 + -parseInt(_0x25ea11(393)) / 3 + -parseInt(_0x25ea11(387)) / 4 + parseInt(_0x25ea11(391)) / 5 * (-parseInt(_0x25ea11(374)) / 6) + parseInt(_0x25ea11(378)) / 7 + parseInt(_0x25ea11(373)) / 8;
      if (_0x348a8b === _0xc974e7) break;
      else _0x550667["push"](_0x550667["shift"]());
    } catch (_0x207f3b) {
      _0x550667["push"](_0x550667["shift"]());
    }
  }
})(_0x68ed, 451791);
function _0x68ed() {
  const _0x2460ac = ["charCodeAt", "UGwjG", "2166056Eofmnm", "toString", "floor", "JyKQz", "9645PezgXa", "ccIcA", "2459124pOygjp", "getTime", "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx", "569921eZDfhN", "12802576WBoZRR", "318qUCfhd", "leWRq", "udNrN", "1215488yqDEIO", "2469257lBvRLZ", "NlDwL", "bhykT", "slice", "length", "lnqfF", "xDxIT"];
  _0x68ed = function() {
    return _0x2460ac;
  };
  return _0x68ed();
}
function generateUUID(_0x30501e) {
  const _0x27c853 = _0x3497, _0x37ef97 = { "bhykT": function(_0x431a71, _0x4c47b0) {
    return _0x431a71 + _0x4c47b0;
  }, "udNrN": function(_0x16db7d, _0x392564) {
    return _0x16db7d << _0x392564;
  }, "NlDwL": function(_0x53e2cd, _0x59c11e) {
    return _0x53e2cd | _0x59c11e;
  }, "leWRq": function(_0xb28ced, _0x39354a) {
    return _0xb28ced % _0x39354a;
  }, "xDxIT": function(_0x4f0bfa, _0x3c12ac) {
    return _0x4f0bfa / _0x3c12ac;
  }, "MrOJR": function(_0x1ff1b3, _0x3394fe) {
    return _0x1ff1b3 == _0x3394fe;
  }, "JyKQz": _0x27c853(371), "ccIcA": function(_0x9f2394, _0x22a317) {
    return _0x9f2394 + _0x22a317;
  }, "UGwjG": function(_0x1c265e, _0x17e46b) {
    return _0x1c265e(_0x17e46b);
  }, "lnqfF": function(_0x358856, _0x140ccc) {
    return _0x358856 < _0x140ccc;
  } };
  let _0x2aae44 = _0x37ef97[_0x27c853(390)], _0x22d19e = (/* @__PURE__ */ new Date())[_0x27c853(370)]();
  const _0x228c9b = _0x37ef97[_0x27c853(392)](_0x30501e, _0x22d19e);
  function _0x54ba23(_0x3637d7) {
    const _0x34dbe1 = _0x27c853;
    let _0x3e0856 = 0;
    for (let _0x511a0e = 0; _0x511a0e < _0x3637d7[_0x34dbe1(382)]; _0x511a0e++) {
      const _0x2549c1 = _0x3637d7[_0x34dbe1(385)](_0x511a0e);
      _0x3e0856 = _0x37ef97[_0x34dbe1(380)](_0x37ef97[_0x34dbe1(376)](_0x3e0856, 5) - _0x3e0856, _0x2549c1), _0x3e0856 |= 0;
    }
    return _0x3e0856;
  }
  let _0x4b5570 = _0x37ef97[_0x27c853(386)](_0x54ba23, _0x228c9b)[_0x27c853(388)](16);
  while (_0x37ef97[_0x27c853(383)](_0x4b5570[_0x27c853(382)], 32)) {
    _0x4b5570 += _0x4b5570;
  }
  _0x4b5570 = _0x4b5570[_0x27c853(381)](0, 32);
  let _0x554972 = 0;
  return _0x2aae44["replace"](/[xy]/g, function(_0x1726b8) {
    const _0x48aa00 = _0x27c853, _0xa595cc = _0x37ef97[_0x48aa00(379)](_0x37ef97[_0x48aa00(375)](_0x22d19e + parseInt(_0x4b5570[_0x554972], 16), 16), 0);
    return _0x22d19e = Math[_0x48aa00(389)](_0x37ef97[_0x48aa00(384)](_0x22d19e, 16)), _0x554972++, (_0x37ef97["MrOJR"](_0x1726b8, "x") ? _0xa595cc : _0xa595cc & 3 | 8)[_0x48aa00(388)](16);
  });
}
const _0x7e67e8 = _0x5769;
function _0x5769(_0x1e4b61, _0x3ba085) {
  const _0xca9e92 = _0xca9e();
  return _0x5769 = function(_0x576955, _0x17ade8) {
    _0x576955 = _0x576955 - 303;
    let _0x35b0cb = _0xca9e92[_0x576955];
    return _0x35b0cb;
  }, _0x5769(_0x1e4b61, _0x3ba085);
}
(function(_0x12c21c, _0x365b14) {
  const _0xbca828 = _0x5769, _0x4bbad6 = _0x12c21c();
  while (!![]) {
    try {
      const _0x3d84fe = -parseInt(_0xbca828(308)) / 1 * (parseInt(_0xbca828(315)) / 2) + -parseInt(_0xbca828(312)) / 3 * (parseInt(_0xbca828(311)) / 4) + -parseInt(_0xbca828(334)) / 5 + parseInt(_0xbca828(347)) / 6 * (parseInt(_0xbca828(320)) / 7) + -parseInt(_0xbca828(309)) / 8 * (parseInt(_0xbca828(338)) / 9) + -parseInt(_0xbca828(345)) / 10 + parseInt(_0xbca828(314)) / 11 * (parseInt(_0xbca828(306)) / 12);
      if (_0x3d84fe === _0x365b14) break;
      else _0x4bbad6["push"](_0x4bbad6["shift"]());
    } catch (_0x298367) {
      _0x4bbad6["push"](_0x4bbad6["shift"]());
    }
  }
})(_0xca9e, 120081);
class SessionController {
  constructor(_0x248152) {
    const _0x12d929 = _0x5769;
    this[_0x12d929(333)] = _0x248152;
  }
  [_0x7e67e8(313)]() {
    var _a;
    const _0x39405d = _0x7e67e8, _0x99721f = { "nFfIG": function(_0xf6e2e4) {
      return _0xf6e2e4();
    }, "eThsB": function(_0x45b6be, _0x29532d) {
      return _0x45b6be === _0x29532d;
    }, "tvrFp": _0x39405d(329), "HxBYa": "UcyQi", "RmBRs": function(_0x37a79f, _0x2b0385) {
      return _0x37a79f(_0x2b0385);
    }, "ZIXad": function(_0x19cc5b, _0x8d0628) {
      return _0x19cc5b(_0x8d0628);
    }, "nnrwK": function(_0x170110, _0xc89962) {
      return _0x170110(_0xc89962);
    } }, _0x503259 = _0x99721f[_0x39405d(348)](vt), _0x4d451a = _0x503259[_0x39405d(335)], _0x5437c0 = (_a = _0x503259[_0x39405d(335)]) == null ? void 0 : _a[_0x39405d(337)];
    !_0x5437c0 && (_0x99721f[_0x39405d(331)](_0x99721f["tvrFp"], _0x99721f[_0x39405d(341)]) ? this[_0x39405d(333)] = _0x4a577c : _0x99721f[_0x39405d(317)](throwError, Errors["USER_DATA_IS_NOT_PROVIDED"])), this[_0x39405d(332)] = { "id": _0x5437c0["id"], "is_premium": _0x5437c0[_0x39405d(339)], "first_name": _0x5437c0[_0x39405d(318)], "is_bot": _0x5437c0["isBot"], "last_name": _0x5437c0[_0x39405d(324)], "language_code": _0x5437c0[_0x39405d(323)], "photo_url": _0x5437c0[_0x39405d(325)], "username": _0x5437c0[_0x39405d(304)] }, this[_0x39405d(328)] = _0x5437c0["id"], this[_0x39405d(340)] = _0x5437c0[_0x39405d(323)], this[_0x39405d(322)] = _0x4d451a[_0x39405d(305)], this[_0x39405d(336)] = _0x503259["platform"], this["sessionId"] = _0x99721f[_0x39405d(344)](generateUUID, _0x99721f[_0x39405d(316)](String, this["getUserId"]()));
  }
  [_0x7e67e8(310)]() {
    const _0x28daac = _0x7e67e8;
    return this[_0x28daac(330)];
  }
  [_0x7e67e8(349)]() {
    return this["userId"];
  }
  [_0x7e67e8(321)]() {
    const _0xa22924 = _0x7e67e8;
    return this[_0xa22924(322)];
  }
  [_0x7e67e8(350)]() {
    const _0x290e38 = _0x7e67e8;
    return this[_0x290e38(336)];
  }
  [_0x7e67e8(303)]() {
    const _0x5ab95c = _0x7e67e8;
    return this[_0x5ab95c(340)];
  }
  ["getUserData"]() {
    const _0x4e6868 = _0x7e67e8;
    return this[_0x4e6868(332)];
  }
  [_0x7e67e8(327)]() {
    const _0x1e0dc6 = _0x7e67e8, _0x371687 = { "VBYgb": function(_0x8e8a07, _0x18ba4d) {
      return _0x8e8a07(_0x18ba4d);
    } }, _0x287609 = this["getUserData"]();
    return _0x371687[_0x1e0dc6(342)](Boolean, _0x287609 == null ? void 0 : _0x287609[_0x1e0dc6(346)]);
  }
  [_0x7e67e8(307)]() {
    const _0x521028 = _0x7e67e8, _0x42cf2c = { "bLMca": function(_0x55a058, _0x1b0640) {
      return _0x55a058(_0x1b0640);
    } };
    return { "session_id": this[_0x521028(310)](), "user_id": this[_0x521028(349)](), "app_name": this[_0x521028(333)][_0x521028(326)](), "is_premium": this[_0x521028(327)](), "platform": this[_0x521028(350)](), "locale": this[_0x521028(303)](), "start_param": this[_0x521028(321)](), "client_timestamp": _0x42cf2c[_0x521028(319)](String, Date[_0x521028(343)]()) };
  }
}
function _0xca9e() {
  const _0x1b04e0 = ["1ryGpvF", "1816JiAbrz", "getSessionId", "104288HDXrxm", "12XKBdNT", "init", "8057489aDYXpB", "139326boQrJn", "nnrwK", "RmBRs", "firstName", "bLMca", "520989IZxNDH", "getWebAppStartParam", "webAppStartParam", "languageCode", "lastName", "photoUrl", "getAppName", "getUserIsPremium", "userId", "FLxLq", "sessionId", "eThsB", "userData", "appModule", "1006725FqZPnr", "initData", "platform", "user", "5247zHZGOf", "isPremium", "userLocale", "HxBYa", "VBYgb", "now", "ZIXad", "1792080rPbfkA", "is_premium", "6hEYZJh", "nFfIG", "getUserId", "getPlatform", "getUserLocale", "username", "startParam", "12wZmOXx", "assembleEventSession"];
  _0xca9e = function() {
    return _0x1b04e0;
  };
  return _0xca9e();
}
const _0x9d1b59 = _0x4176;
(function(_0x5877e5, _0x51147a) {
  const _0x488701 = _0x4176, _0x5acf9e = _0x5877e5();
  while (!![]) {
    try {
      const _0x2465ff = -parseInt(_0x488701(410)) / 1 + parseInt(_0x488701(411)) / 2 * (-parseInt(_0x488701(416)) / 3) + -parseInt(_0x488701(417)) / 4 + -parseInt(_0x488701(414)) / 5 + parseInt(_0x488701(412)) / 6 * (parseInt(_0x488701(408)) / 7) + parseInt(_0x488701(423)) / 8 + parseInt(_0x488701(413)) / 9;
      if (_0x2465ff === _0x51147a) break;
      else _0x5acf9e["push"](_0x5acf9e["shift"]());
    } catch (_0xc78e9) {
      _0x5acf9e["push"](_0x5acf9e["shift"]());
    }
  }
})(_0x5eab, 734784);
function _0x4176(_0x54a71b, _0x429ccd) {
  const _0x5eab95 = _0x5eab();
  return _0x4176 = function(_0x4176b0, _0x38468a) {
    _0x4176b0 = _0x4176b0 - 408;
    let _0x31dbe3 = _0x5eab95[_0x4176b0];
    return _0x31dbe3;
  }, _0x4176(_0x54a71b, _0x429ccd);
}
class BatchStorage {
  constructor(_0x5cdb6f) {
    const _0x1aa710 = _0x4176;
    this["sessionStorage"] = window["sessionStorage"], this["localStorage"] = window[_0x1aa710(419)], this["key"] = _0x5cdb6f;
  }
  ["getBatch"]() {
    const _0x554e86 = _0x4176, _0x4d53e4 = { "TnOVd": _0x554e86(421), "Bioni": function(_0x55f8c9, _0x398ec9) {
      return _0x55f8c9 !== _0x398ec9;
    }, "rreLP": "pMtHA", "SISWo": _0x554e86(431) };
    if ([null, _0x4d53e4[_0x554e86(429)]][_0x554e86(409)](this[_0x554e86(427)][_0x554e86(426)](this[_0x554e86(418)])) && [null, _0x554e86(421)][_0x554e86(409)](this[_0x554e86(419)][_0x554e86(426)](this[_0x554e86(418)]))) {
      if (_0x4d53e4[_0x554e86(415)](_0x4d53e4["rreLP"], _0x4d53e4["SISWo"])) this[_0x554e86(428)]([]);
      else {
        const _0x2ac006 = this[_0x554e86(420)]();
        _0x2ac006["push"]({ "event_name": _0x4a4b32, ..._0x14dd36 }), this[_0x554e86(428)](_0x2ac006);
      }
    } else this["setItem"](JSON[_0x554e86(424)](this["localStorage"][_0x554e86(426)](this["key"])));
    return this[_0x554e86(428)]([...JSON[_0x554e86(424)](this[_0x554e86(427)]["getItem"](this[_0x554e86(418)])), ...JSON["parse"](this[_0x554e86(419)][_0x554e86(426)](this["key"]))]["filter"]((_0x63aae8, _0x1e5252, _0x2d3264) => _0x2d3264[_0x554e86(425)]((_0x3815b4) => JSON[_0x554e86(430)](_0x3815b4) === JSON["stringify"](_0x63aae8)) === _0x1e5252)), JSON[_0x554e86(424)](this[_0x554e86(427)][_0x554e86(426)](this["key"]));
  }
  [_0x9d1b59(422)](_0x40d080, _0x4821dd) {
    const _0x1e6b32 = _0x9d1b59, _0x4cf9d2 = this[_0x1e6b32(420)]();
    _0x4cf9d2["push"]({ "event_name": _0x40d080, ..._0x4821dd }), this["setItem"](_0x4cf9d2);
  }
  [_0x9d1b59(428)](_0x534c62) {
    const _0x1ebde8 = _0x9d1b59;
    this[_0x1ebde8(419)][_0x1ebde8(428)](this["key"], JSON["stringify"](_0x534c62)), this[_0x1ebde8(427)][_0x1ebde8(428)](this[_0x1ebde8(418)], JSON[_0x1ebde8(430)](_0x534c62));
  }
}
function _0x5eab() {
  const _0x460df6 = ["setItem", "TnOVd", "stringify", "pSdMg", "161bdjUhY", "includes", "621522NwBGpW", "6238gEOiBb", "257598sQgKcc", "16344702aDiJAz", "5763205DgchCn", "Bioni", "927qCsYNz", "3153560QYFLeX", "key", "localStorage", "getBatch", "null", "addToStorage", "11660568mQhkZs", "parse", "findIndex", "getItem", "sessionStorage"];
  _0x5eab = function() {
    return _0x460df6;
  };
  return _0x5eab();
}
function _0x3d25() {
  const _0x119cb2 = ["onreadystatechange", "complete", "fkrDh", "xhduB", "124thBiXo", "Njkhw", "Upxyg", "startBatchingWithInterval", "processQueue", "114weiJKA", "HSPcW", "RdoDI", "21287EPJXiV", "solveTask", "KshVo", "TJppy", "cxGiR", "readyState", "nMXcT", "waXjt", "load", "FEGct", "onLine", "VTNSh", "9829MvQDdk", "startBatching", "EWuep", "nQoDH", "5776731ROGzKC", "635371mwBJzM", "PRtAD", "hElfu", "vvfXs", "JVpTh", "BATCH_KEY", "MjDhS", "1840904SJddph", "1029018vdWRhH", "stopBatching", "ZjmOd", "CKtnH", "SxkEY", "kxWAF", "zcYRz", "taskSolution", "5|1|6|3|0|2|4", "recordEvents", "nDbFC", "fBKDO", "collect", "VPdzS", "getBatch", "OcXOL", "length", "fceWv", "setItem", "collectEvent", "WRRtl", "vXrxr", "XoOOe", "xQCIt", "init", "status", "storage", "getApiToken", "WYdZI", "log", "moVca", "appModule", "bALIF", "Qwrgs", "hYdFm", "tkiwy", "intervalId", "setInterval", "EaIIJ", "OUemL", "dHXCx", "IrvCa", "NOUCv", "addEventListener", "48vaBLiG", "stringify", "TGKgK", "navigator", "sendBatch", "NdQqJ", "FRmjY", "batchInterval", "380DARqwM", "203", "eYrcY", "LiGoP", "backoff", "YyeNJ", "addToStorage", "mUKDh", "taskRetry", "yuRnB", "66295whXzsL", "peTDg", "AiSEp", "some", "slice", "gitSM", "429"];
  _0x3d25 = function() {
    return _0x119cb2;
  };
  return _0x3d25();
}
const _0x14989d = _0x1c0e;
function _0x1c0e(_0x5bb9ac, _0xaedd83) {
  const _0x3d2556 = _0x3d25();
  return _0x1c0e = function(_0x1c0e45, _0x14a5eb) {
    _0x1c0e45 = _0x1c0e45 - 127;
    let _0x5024ca = _0x3d2556[_0x1c0e45];
    return _0x5024ca;
  }, _0x1c0e(_0x5bb9ac, _0xaedd83);
}
(function(_0x5cfd9f, _0x1c2039) {
  const _0x2df14c = _0x1c0e, _0x11429b = _0x5cfd9f();
  while (!![]) {
    try {
      const _0x2b7d07 = -parseInt(_0x2df14c(198)) / 1 * (parseInt(_0x2df14c(183)) / 2) + -parseInt(_0x2df14c(211)) / 3 + parseInt(_0x2df14c(178)) / 4 * (-parseInt(_0x2df14c(167)) / 5) + parseInt(_0x2df14c(149)) / 6 * (-parseInt(_0x2df14c(186)) / 7) + parseInt(_0x2df14c(210)) / 8 + -parseInt(_0x2df14c(202)) / 9 + parseInt(_0x2df14c(157)) / 10 * (parseInt(_0x2df14c(203)) / 11);
      if (_0x2b7d07 === _0x1c2039) break;
      else _0x11429b["push"](_0x11429b["shift"]());
    } catch (_0x1ac7fd) {
      _0x11429b["push"](_0x11429b["shift"]());
    }
  }
})(_0x3d25, 444556);
class BatchService {
  constructor(_0xc1e6b6) {
    const _0x2681b9 = _0x1c0e, _0x3efd3e = { "tkiwy": _0x2681b9(219), "TGKgK": function(_0x4d60c8, _0x207b02) {
      return _0x4d60c8 + _0x207b02;
    } }, _0x4115b0 = _0x3efd3e[_0x2681b9(140)]["split"]("|");
    let _0x25d41e = 0;
    while (!![]) {
      switch (_0x4115b0[_0x25d41e++]) {
        case "0":
          this[_0x2681b9(208)] = BATCH_KEY;
          continue;
        case "1":
          this[_0x2681b9(141)] = null;
          continue;
        case "2":
          this["appModule"] = _0xc1e6b6;
          continue;
        case "3":
          this[_0x2681b9(165)] = 0;
          continue;
        case "4":
          this[_0x2681b9(131)] = new BatchStorage(_0x3efd3e[_0x2681b9(151)](this[_0x2681b9(208)], "-") + this[_0x2681b9(136)][_0x2681b9(132)]());
          continue;
        case "5":
          this[_0x2681b9(161)] = 1;
          continue;
        case "6":
          this[_0x2681b9(156)] = 2e3;
          continue;
      }
      break;
    }
  }
  [_0x14989d(129)]() {
    const _0x354ced = _0x14989d, _0x57bcc1 = { "xhduB": function(_0x1377af, _0x554cb5) {
      return _0x1377af !== _0x554cb5;
    }, "fceWv": "XqMyF", "KshVo": _0x354ced(175), "vvfXs": _0x354ced(222), "HSPcW": "qoYZA", "WYdZI": function(_0x449b2a, _0x2d6cd5) {
      return _0x449b2a === _0x2d6cd5;
    } };
    _0x57bcc1[_0x354ced(133)](document["readyState"], "complete") ? this[_0x354ced(181)]() : document[_0x354ced(174)] = () => {
      const _0x38eb64 = _0x354ced;
      _0x57bcc1[_0x38eb64(177)](_0x57bcc1["fceWv"], _0x57bcc1[_0x38eb64(228)]) ? (_0xbdf8c2[_0x38eb64(134)](_0x851523), this[_0x38eb64(199)]()) : document[_0x38eb64(191)] == _0x57bcc1[_0x38eb64(188)] && (_0x57bcc1["xhduB"](_0x57bcc1[_0x38eb64(206)], _0x57bcc1[_0x38eb64(184)]) ? this[_0x38eb64(181)]() : this[_0x38eb64(181)]());
    };
  }
  [_0x14989d(181)]() {
    const _0x5ef25d = _0x14989d, _0x23bd0e = { "nQoDH": function(_0x23b692) {
      return _0x23b692();
    }, "peTDg": function(_0x5bd609, _0x2a7817) {
      return _0x5bd609 !== _0x2a7817;
    }, "pswxI": function(_0x587819, _0x32467e) {
      return _0x587819(_0x32467e);
    }, "zcYRz": function(_0x4fc962, _0x21b988) {
      return _0x4fc962 === _0x21b988;
    }, "Upxyg": _0x5ef25d(190), "WRRtl": _0x5ef25d(159), "FRmjY": _0x5ef25d(179), "NqZaw": function(_0x292d49, _0x124f54, _0xad5e1b) {
      return _0x292d49(_0x124f54, _0xad5e1b);
    } };
    let _0x268c5e = 0;
    this[_0x5ef25d(136)][_0x5ef25d(187)](), this["appModule"][_0x5ef25d(230)](Events["INIT"]);
    if (_0x23bd0e["peTDg"](this[_0x5ef25d(136)][_0x5ef25d(218)], void 0)) _0x23bd0e[_0x5ef25d(231)] === _0x23bd0e[_0x5ef25d(155)] ? _0x23bd0e[_0x5ef25d(201)](_0x34f907) : this[_0x5ef25d(199)]();
    else {
      const _0x1d1c74 = _0x23bd0e["NqZaw"](setInterval, () => {
        const _0x29ebe2 = _0x5ef25d;
        if (_0x23bd0e[_0x29ebe2(168)](this[_0x29ebe2(136)][_0x29ebe2(218)], void 0)) this[_0x29ebe2(199)](), _0x23bd0e["pswxI"](clearInterval, _0x1d1c74);
        else {
          if (_0x268c5e++ >= 3) {
            if (_0x23bd0e[_0x29ebe2(217)](_0x23bd0e["Upxyg"], _0x23bd0e[_0x29ebe2(180)])) {
              this[_0x29ebe2(199)](), clearInterval(_0x1d1c74);
              return;
            } else this[_0x29ebe2(131)][_0x29ebe2(163)](_0x20dd77, _0x2e5ee2);
          }
          this[_0x29ebe2(136)][_0x29ebe2(187)]();
        }
      }, 1e3);
    }
  }
  [_0x14989d(212)]() {
    const _0x3fb015 = _0x14989d, _0x59fa8e = { "YyeNJ": function(_0x8c159f, _0x30253d) {
      return _0x8c159f !== _0x30253d;
    }, "IrvCa": function(_0x4a069c, _0x2d51b9) {
      return _0x4a069c(_0x2d51b9);
    } };
    _0x59fa8e[_0x3fb015(162)](this[_0x3fb015(141)], null) && (_0x59fa8e[_0x3fb015(146)](clearInterval, this[_0x3fb015(141)]), this[_0x3fb015(141)] = null);
  }
  [_0x14989d(223)](_0x49506c, _0x212d30) {
    const _0x4cd563 = _0x14989d, _0x513c11 = { "LiGoP": function(_0x524f33, _0xfe6904) {
      return _0x524f33 < _0xfe6904;
    }, "TJppy": function(_0x16cf24, _0x28edd8) {
      return _0x16cf24 * _0x28edd8;
    }, "RdoDI": function(_0x2ec5ac, _0x3e4a3e) {
      return _0x2ec5ac === _0x3e4a3e;
    }, "FEGct": _0x4cd563(175), "OcXOL": function(_0x4ff172, _0x231da2) {
      return _0x4ff172 !== _0x231da2;
    }, "PQRJt": "moVca", "EaIIJ": _0x4cd563(194), "fkrDh": function(_0x16c29c, _0x5a9d6e, _0x9ee4f8) {
      return _0x16c29c(_0x5a9d6e, _0x9ee4f8);
    } };
    if (_0x513c11["RdoDI"](document[_0x4cd563(191)], _0x513c11[_0x4cd563(195)])) this[_0x4cd563(131)][_0x4cd563(163)](_0x49506c, _0x212d30);
    else {
      const _0x2b55b4 = () => {
        const _0x5b18e0 = _0x4cd563;
        this[_0x5b18e0(131)][_0x5b18e0(163)](_0x49506c, _0x212d30);
      };
      _0x513c11[_0x4cd563(176)](setTimeout, () => {
        const _0x5e61c6 = _0x4cd563;
        if (_0x513c11[_0x5e61c6(185)](document[_0x5e61c6(191)], _0x513c11[_0x5e61c6(195)])) _0x2b55b4();
        else {
          if (_0x513c11[_0x5e61c6(226)](_0x513c11["PQRJt"], _0x5e61c6(135))) {
            _0x513c11[_0x5e61c6(160)](this[_0x5e61c6(161)], 5) && (this[_0x5e61c6(161)]++, this[_0x5e61c6(156)] = _0x513c11[_0x5e61c6(189)](this[_0x5e61c6(156)], 2.71), this[_0x5e61c6(199)]());
            return;
          } else window[_0x5e61c6(148)](_0x513c11[_0x5e61c6(143)], _0x2b55b4);
        }
      }, 0);
    }
  }
  [_0x14989d(199)]() {
    const _0xb5594f = _0x14989d, _0x1c8ad8 = { "bALIF": function(_0x41d24b, _0x3075b0) {
      return _0x41d24b !== _0x3075b0;
    }, "wWNxP": function(_0x43ed03, _0x3d120f) {
      return _0x43ed03(_0x3d120f);
    }, "EWuep": function(_0xd6da5d, _0x119ea7) {
      return _0xd6da5d === _0x119ea7;
    }, "kxWAF": _0xb5594f(232) };
    this[_0xb5594f(136)][_0xb5594f(187)](), _0x1c8ad8[_0xb5594f(200)](this[_0xb5594f(141)], null) && (_0x1c8ad8[_0xb5594f(137)](_0x1c8ad8[_0xb5594f(216)], _0xb5594f(232)) ? _0x1c8ad8[_0xb5594f(137)](this[_0xb5594f(141)], null) && (_0x1c8ad8["wWNxP"](_0x152b8a, this[_0xb5594f(141)]), this[_0xb5594f(141)] = null) : this[_0xb5594f(141)] = window[_0xb5594f(142)](() => this[_0xb5594f(182)](), this[_0xb5594f(156)]));
  }
  [_0x14989d(182)]() {
    const _0x149c6e = _0x14989d, _0x189f51 = { "CKtnH": function(_0xbabc1c, _0x4b3612) {
      return _0xbabc1c !== _0x4b3612;
    } }, _0x575d4a = this["storage"][_0x149c6e(225)]();
    _0x189f51[_0x149c6e(214)](_0x575d4a[_0x149c6e(227)], 0) && window[_0x149c6e(152)][_0x149c6e(196)] && this[_0x149c6e(153)](_0x575d4a[_0x149c6e(171)](0, 20));
  }
  [_0x14989d(153)](_0x57f0fb) {
    const _0x223775 = _0x14989d, _0x561a47 = { "AiSEp": function(_0x548106, _0x30fbb1) {
      return _0x548106(_0x30fbb1);
    }, "Cvwxi": function(_0x21cdf6, _0x80cb2e) {
      return _0x21cdf6 >= _0x80cb2e;
    }, "OUemL": function(_0x37948c, _0x7996f0) {
      return _0x37948c == _0x7996f0;
    }, "waXjt": _0x223775(175), "VPdzS": function(_0x574599, _0xe49880) {
      return _0x574599 === _0xe49880;
    }, "ZjmOd": function(_0x5130db, _0x2d3747) {
      return _0x5130db(_0x2d3747);
    }, "PRtAD": _0x223775(173), "woTWb": _0x223775(209), "NdQqJ": function(_0x4f2931, _0x35d747) {
      return _0x4f2931 === _0x35d747;
    }, "nMXcT": function(_0x543040, _0x367826) {
      return _0x543040(_0x367826);
    }, "mUKDh": function(_0x4117ba, _0x1db055) {
      return _0x4117ba === _0x1db055;
    }, "xQCIt": _0x223775(221), "ooiFC": function(_0x3fe41d, _0x11c0fd) {
      return _0x3fe41d < _0x11c0fd;
    }, "NOUCv": "WwnvF", "hYdFm": function(_0x495ee2, _0x8ed97a) {
      return _0x495ee2 * _0x8ed97a;
    }, "VTNSh": function(_0x45b1a8, _0x15ecb7) {
      return _0x45b1a8(_0x15ecb7);
    }, "kSLCl": _0x223775(158), "hElfu": function(_0x2a96de, _0x105266) {
      return _0x2a96de !== _0x105266;
    }, "dHXCx": _0x223775(215), "Qwrgs": _0x223775(166), "gitSM": _0x223775(127) };
    this[_0x223775(212)](), this["appModule"][_0x223775(220)](_0x57f0fb)["then"]((_0x8a33e5) => {
      const _0x4c2d97 = _0x223775, _0x2e167f = { "JVpTh": function(_0x2d174d, _0x2dfadf) {
        const _0x1a3433 = _0x1c0e;
        return _0x561a47[_0x1a3433(144)](_0x2d174d, _0x2dfadf);
      }, "FeGnm": _0x561a47[_0x4c2d97(193)] };
      if (_0x561a47[_0x4c2d97(224)](_0x561a47[_0x4c2d97(213)](String, _0x8a33e5[_0x4c2d97(130)]), _0x561a47[_0x4c2d97(204)])) {
        if (_0x4c2d97(209) !== _0x561a47["woTWb"]) this["startBatching"](), _0x561a47["AiSEp"](_0x2b6bb4, _0x5644c6);
        else {
          this[_0x4c2d97(199)]();
          return;
        }
      }
      if (_0x561a47[_0x4c2d97(154)](_0x561a47[_0x4c2d97(192)](String, _0x8a33e5[_0x4c2d97(130)])[0], "4")) return;
      if (_0x561a47["mUKDh"](_0x561a47[_0x4c2d97(192)](String, _0x8a33e5[_0x4c2d97(130)])[0], "5")) {
        if (_0x561a47[_0x4c2d97(224)](_0x561a47[_0x4c2d97(128)], "nDbFC")) {
          _0x561a47["ooiFC"](this[_0x4c2d97(161)], 5) && (_0x561a47[_0x4c2d97(154)](_0x561a47[_0x4c2d97(147)], _0x561a47[_0x4c2d97(147)]) ? (this[_0x4c2d97(161)]++, this[_0x4c2d97(156)] = _0x561a47[_0x4c2d97(139)](this[_0x4c2d97(156)], 2.71), this["startBatching"]()) : this["intervalId"] = _0x380f34["setInterval"](() => this["processQueue"](), this["batchInterval"]));
          return;
        } else this[_0x4c2d97(153)](_0x89adb8[_0x4c2d97(171)](0, 20));
      }
      this[_0x4c2d97(161)] = 1, this[_0x4c2d97(156)] = 2e3;
      if (_0x561a47[_0x4c2d97(164)](_0x561a47[_0x4c2d97(197)](String, _0x8a33e5["status"]), _0x561a47["kSLCl"])) {
        if (_0x561a47[_0x4c2d97(205)](_0x4c2d97(215), _0x561a47[_0x4c2d97(145)])) _0x2e167f[_0x4c2d97(207)](_0x3c73c0[_0x4c2d97(191)], _0x2e167f["FeGnm"]) && this[_0x4c2d97(181)]();
        else {
          this[_0x4c2d97(165)]++, this[_0x4c2d97(136)][_0x4c2d97(218)] = void 0;
          if (this[_0x4c2d97(165)] > 3) {
            this[_0x4c2d97(199)]();
            return;
          } else {
            if (_0x561a47[_0x4c2d97(164)](_0x561a47[_0x4c2d97(138)], _0x561a47[_0x4c2d97(172)])) {
              if (_0x561a47["Cvwxi"](_0x5e3add++, 3)) {
                this["startBatching"](), _0x561a47[_0x4c2d97(169)](_0x3bc16a, _0x21b10b);
                return;
              }
              this[_0x4c2d97(136)][_0x4c2d97(187)]();
            } else {
              this[_0x4c2d97(136)][_0x4c2d97(187)](), this[_0x4c2d97(199)]();
              return;
            }
          }
        }
      }
      this[_0x4c2d97(165)] = 0, this["storage"][_0x4c2d97(229)](this["storage"][_0x4c2d97(225)]()["filter"]((_0x1e8b12) => !_0x57f0fb[_0x4c2d97(170)]((_0x24ab31) => JSON["stringify"](_0x1e8b12) === JSON[_0x4c2d97(150)](_0x24ab31)))), this[_0x4c2d97(199)]();
    }, (_0x4e483b) => {
      const _0x5b9871 = _0x223775;
      console[_0x5b9871(134)](_0x4e483b), this[_0x5b9871(199)]();
    });
  }
}
function _0x3bc3(_0x278ae0, _0x22e69c) {
  var _0x4df9d5 = _0x4df9();
  return _0x3bc3 = function(_0x3bc327, _0x446fe7) {
    _0x3bc327 = _0x3bc327 - 384;
    var _0x4a5505 = _0x4df9d5[_0x3bc327];
    return _0x4a5505;
  }, _0x3bc3(_0x278ae0, _0x22e69c);
}
function _0x4df9() {
  var _0x30ced7 = ["text", "oMdRO", "15xjOkTP", "LHyOV", "15752Mveonz", "oOsLJ", "853785wEavVv", "2050MFXzXk", "appModule", "2441624UyfOnX", "then", "581LHkPuF", "xvNwp", "aee7c93a9ae7930fb19732325d2c560c53849aa7", "nOpNo", "worker", "plCLN", "2UBxDZz", "onmessage", "Lrrvr", "setNewArgs", "postMessage", "2364132JuXcVp", "NFKyb", "13zGsvlE", "taskSolution", "data", "dHrOl", "DYaOZ", "blob", "lsqpT", "95976zuEMZh", "QaYBi", "9GxRsnL", "solveTask", "wejTR", "createObjectURL", "GnAxB", "aYRUp", "4644EDaQit", "354397rxKEDw", "taskParams"];
  _0x4df9 = function() {
    return _0x30ced7;
  };
  return _0x4df9();
}
var _0x34cc0a = _0x3bc3;
(function(_0x1b336f, _0xedd5ed) {
  var _0x1eb993 = _0x3bc3, _0x1431ac = _0x1b336f();
  while (!![]) {
    try {
      var _0x15ed1e = parseInt(_0x1eb993(420)) / 1 * (parseInt(_0x1eb993(397)) / 2) + -parseInt(_0x1eb993(424)) / 3 * (parseInt(_0x1eb993(411)) / 4) + -parseInt(_0x1eb993(386)) / 5 + -parseInt(_0x1eb993(419)) / 6 * (parseInt(_0x1eb993(391)) / 7) + -parseInt(_0x1eb993(389)) / 8 * (parseInt(_0x1eb993(413)) / 9) + -parseInt(_0x1eb993(387)) / 10 * (-parseInt(_0x1eb993(384)) / 11) + parseInt(_0x1eb993(402)) / 12 * (parseInt(_0x1eb993(404)) / 13);
      if (_0x15ed1e === _0xedd5ed) break;
      else _0x1431ac["push"](_0x1431ac["shift"]());
    } catch (_0x1ab059) {
      _0x1431ac["push"](_0x1431ac["shift"]());
    }
  }
})(_0x4df9, 184796);
class HumanProofService {
  constructor(_0x44aba7) {
    this["appModule"] = _0x44aba7;
  }
  async ["init"]() {
    var _0xd88301 = _0x3bc3, _0x4798d8 = { "oMdRO": _0xd88301(417), "WfOgB": function(_0x9af2c4, _0x43f866) {
      return _0x9af2c4(_0x43f866);
    }, "wBffF": function(_0x41a817, _0x14f01a) {
      return _0x41a817 + _0x14f01a;
    }, "kPAPB": _0xd88301(393), "Lrrvr": function(_0x568f0b, _0x47cec2) {
      return _0x568f0b !== _0x47cec2;
    }, "FWcyR": function(_0x44b7d9) {
      return _0x44b7d9();
    }, "aYRUp": function(_0xed9114, _0x438b9c) {
      return _0xed9114(_0x438b9c);
    }, "qlSvI": _0xd88301(396), "dHrOl": _0xd88301(394) };
    return new Promise(async (_0x595948, _0x1230f8) => {
      var _0x3e267b = _0xd88301, _0x2405ae = { "pKPvx": function(_0x2c5ba0, _0x3f6d56) {
        var _0x5c9fe4 = _0x3bc3;
        return _0x4798d8[_0x5c9fe4(399)](_0x2c5ba0, _0x3f6d56);
      }, "NFKyb": function(_0x27b284, _0x51307f) {
        return _0x27b284 !== _0x51307f;
      }, "DYaOZ": _0x3e267b(385), "LHyOV": function(_0x141864) {
        return _0x4798d8["FWcyR"](_0x141864);
      } };
      try {
        await _0x4798d8[_0x3e267b(418)](fetch, _0x4798d8["wBffF"](BACKEND_URL, "c3e068ebf11840ed3fc311a6f2df80b20fa05d25"))["then"](async (_0x2297f4) => {
          var _0x342f2f = _0x3e267b, _0x228d3f = { "xvNwp": function(_0x320ae9, _0x1e5a89) {
            return _0x320ae9 === _0x1e5a89;
          }, "QaYBi": _0x4798d8[_0x342f2f(423)] };
          this[_0x342f2f(395)] = new Worker(URL[_0x342f2f(416)](await _0x2297f4[_0x342f2f(409)]())), await _0x4798d8["WfOgB"](fetch, _0x4798d8["wBffF"](BACKEND_URL, _0x4798d8["kPAPB"]))[_0x342f2f(390)](async (_0x28b2c6) => {
            var _0x547cb4 = _0x342f2f, _0xe55cc2 = { "wejTR": function(_0x38f7b5, _0x30d33e) {
              return _0x2405ae["pKPvx"](_0x38f7b5, _0x30d33e);
            } };
            _0x2405ae[_0x547cb4(403)](_0x547cb4(385), _0x2405ae[_0x547cb4(408)]) ? _0xe55cc2[_0x547cb4(415)](this[_0x547cb4(395)], void 0) && this[_0x547cb4(395)][_0x547cb4(401)](this[_0x547cb4(388)][_0x547cb4(421)]) : (this[_0x547cb4(388)]["taskParams"] = String(await _0x28b2c6[_0x547cb4(422)]()), this[_0x547cb4(395)][_0x547cb4(398)] = (_0x2ac410) => {
              var _0x558b97 = _0x547cb4;
              _0x228d3f[_0x558b97(392)](_0x228d3f[_0x558b97(412)], _0x228d3f[_0x558b97(412)]) ? this["appModule"][_0x558b97(405)] = _0x2ac410[_0x558b97(406)] : (this[_0x558b97(388)]["taskParams"] = _0x3091f7, this["solveTask"]());
            }, _0x2405ae[_0x547cb4(425)](_0x595948));
          });
        });
      } catch (_0x2a5318) {
        _0x4798d8[_0x3e267b(399)](_0x4798d8["qlSvI"], _0x4798d8[_0x3e267b(407)]) ? _0x4798d8[_0x3e267b(418)](_0x1230f8, _0x2a5318) : _0x13dd48(_0xc3e6f6);
      }
    });
  }
  [_0x34cc0a(400)](_0x5e82cf) {
    var _0x20c3d4 = _0x34cc0a;
    this[_0x20c3d4(388)]["taskParams"] = _0x5e82cf, this[_0x20c3d4(414)]();
  }
  [_0x34cc0a(414)]() {
    var _0x2f71d3 = _0x34cc0a, _0x4d4d28 = { "lsqpT": function(_0x256dd7, _0x616f6d) {
      return _0x256dd7 !== _0x616f6d;
    } };
    _0x4d4d28[_0x2f71d3(410)](this[_0x2f71d3(395)], void 0) && this[_0x2f71d3(395)][_0x2f71d3(401)](this[_0x2f71d3(388)][_0x2f71d3(421)]);
  }
}
function _0x47f6() {
  var _0xc93409 = ["9mkdUTQ", "assembleEventSession", "5|6|2|4|0|7|3|1", "2367928HORQEo", "238726BSVMev", "setNewArgs", "recordEvents", "catch", "getAppName", "6ngVFuG", "analyticsController", "collect", "registerInvoice", "split", "1184253BQzXgq", "1538128mJnsMl", "networkController", "INVOICE_REGISTERED", "4|3|1|0|2", "2IZUBEG", "sessionController", "humanProofService", "appName", "13517110AAgEcR", "init", "227223wrNoYf", "collectEvent", "env", "2719245LBWXIy", "solveTask", "getUserData", "getApiToken", "error", "batchService", "apiToken", "then", "collectTappsEvent"];
  _0x47f6 = function() {
    return _0xc93409;
  };
  return _0x47f6();
}
var _0x35debb = _0x2f71;
(function(_0x2aa957, _0x290bc2) {
  var _0x1e46bd = _0x2f71, _0x9a4f93 = _0x2aa957();
  while (!![]) {
    try {
      var _0x11cec5 = -parseInt(_0x1e46bd(205)) / 1 * (-parseInt(_0x1e46bd(220)) / 2) + parseInt(_0x1e46bd(189)) / 3 + -parseInt(_0x1e46bd(216)) / 4 + -parseInt(_0x1e46bd(192)) / 5 * (parseInt(_0x1e46bd(210)) / 6) + -parseInt(_0x1e46bd(215)) / 7 + -parseInt(_0x1e46bd(204)) / 8 + -parseInt(_0x1e46bd(201)) / 9 * (-parseInt(_0x1e46bd(224)) / 10);
      if (_0x11cec5 === _0x290bc2) break;
      else _0x9a4f93["push"](_0x9a4f93["shift"]());
    } catch (_0x291fd0) {
      _0x9a4f93["push"](_0x9a4f93["shift"]());
    }
  }
})(_0x47f6, 272627);
function _0x2f71(_0x58a5de, _0x2e90dc) {
  var _0x47f6dd = _0x47f6();
  return _0x2f71 = function(_0x2f7193, _0x106cac) {
    _0x2f7193 = _0x2f7193 - 188;
    var _0x10d283 = _0x47f6dd[_0x2f7193];
    return _0x10d283;
  }, _0x2f71(_0x58a5de, _0x2e90dc);
}
class App {
  constructor(_0x1c9a58, _0xd374ea, _0x2ede14) {
    var _0x2f0b27 = _0x2f71, _0x458a4d = _0x2f0b27(203)[_0x2f0b27(214)]("|"), _0x730257 = 0;
    while (!![]) {
      switch (_0x458a4d[_0x730257++]) {
        case "0":
          this["sessionController"] = new SessionController(this);
          continue;
        case "1":
          this[_0x2f0b27(197)] = new BatchService(this);
          continue;
        case "2":
          this[_0x2f0b27(223)] = _0xd374ea;
          continue;
        case "3":
          this[_0x2f0b27(211)] = new AnalyticsController(this);
          continue;
        case "4":
          this[_0x2f0b27(222)] = new HumanProofService(this);
          continue;
        case "5":
          this[_0x2f0b27(191)] = _0x2ede14;
          continue;
        case "6":
          this[_0x2f0b27(198)] = _0x1c9a58;
          continue;
        case "7":
          this[_0x2f0b27(217)] = new NetworkController(this);
          continue;
      }
      break;
    }
  }
  async [_0x35debb(188)]() {
    var _0x5c53db = _0x35debb, _0x3922df = _0x5c53db(219)[_0x5c53db(214)]("|"), _0x347327 = 0;
    while (!![]) {
      switch (_0x3922df[_0x347327++]) {
        case "0":
          this[_0x5c53db(217)][_0x5c53db(188)]();
          continue;
        case "1":
          await this[_0x5c53db(222)][_0x5c53db(188)]()[_0x5c53db(199)](() => {
            this["solveTask"]();
          })[_0x5c53db(208)]((_0x55e295) => console[_0x5c53db(196)](_0x55e295));
          continue;
        case "2":
          this[_0x5c53db(197)]["init"]();
          continue;
        case "3":
          await this[_0x5c53db(211)][_0x5c53db(188)]();
          continue;
        case "4":
          this[_0x5c53db(221)][_0x5c53db(188)]();
          continue;
      }
      break;
    }
  }
  [_0x35debb(202)]() {
    var _0x2f1825 = _0x35debb;
    return this[_0x2f1825(221)][_0x2f1825(202)]();
  }
  ["recordEvent"](_0x2bb149, _0x3e1e20, _0x4026f9) {
    return this["networkController"]["recordEvent"](_0x2bb149, _0x3e1e20, _0x4026f9);
  }
  [_0x35debb(207)](_0x250944) {
    var _0x4eea9b = _0x35debb;
    return this["networkController"][_0x4eea9b(207)](_0x250944);
  }
  [_0x35debb(190)](_0x82ade9, _0x504e16) {
    var _0x2fcd3f = _0x35debb;
    this[_0x2fcd3f(197)][_0x2fcd3f(212)](_0x82ade9, { ..._0x504e16, ...this[_0x2fcd3f(202)]() });
  }
  [_0x35debb(213)](_0x1607da) {
    var _0xb93b86 = _0x35debb;
    this[_0xb93b86(197)][_0xb93b86(212)](Events[_0xb93b86(218)], { ..._0x1607da, ...this[_0xb93b86(202)]() });
  }
  [_0x35debb(200)](_0x822756, _0x51b59d) {
    var _0x48adec = _0x35debb;
    this[_0x48adec(197)]["collect"](_0x822756, { ...this[_0x48adec(221)][_0x48adec(202)](), "custom_data": { "userData": { ...this[_0x48adec(221)][_0x48adec(194)]() }, ..._0x51b59d } });
  }
  [_0x35debb(195)]() {
    return this["apiToken"];
  }
  [_0x35debb(209)]() {
    var _0x4a66df = _0x35debb;
    return this[_0x4a66df(223)];
  }
  ["solveTask"]() {
    var _0xf6f6ce = _0x35debb;
    this[_0xf6f6ce(222)][_0xf6f6ce(193)]();
  }
  ["setNewArgs"](_0x2f613c) {
    var _0xf67ad0 = _0x35debb;
    this[_0xf67ad0(222)][_0xf67ad0(206)](_0x2f613c);
  }
}
(function(_0x43250a, _0x4f6f17) {
  const _0x3d076b = _0x45ea, _0x5d7b46 = _0x43250a();
  while (!![]) {
    try {
      const _0x297720 = -parseInt(_0x3d076b(487)) / 1 * (-parseInt(_0x3d076b(514)) / 2) + -parseInt(_0x3d076b(480)) / 3 * (parseInt(_0x3d076b(496)) / 4) + -parseInt(_0x3d076b(513)) / 5 * (-parseInt(_0x3d076b(516)) / 6) + -parseInt(_0x3d076b(504)) / 7 + -parseInt(_0x3d076b(449)) / 8 * (parseInt(_0x3d076b(451)) / 9) + parseInt(_0x3d076b(468)) / 10 + parseInt(_0x3d076b(493)) / 11 * (parseInt(_0x3d076b(530)) / 12);
      if (_0x297720 === _0x4f6f17) break;
      else _0x5d7b46["push"](_0x5d7b46["shift"]());
    } catch (_0x5b6aff) {
      _0x5d7b46["push"](_0x5d7b46["shift"]());
    }
  }
})(_0xe3b4, 871742);
function validateInvoicePayload(_0x4baa99) {
  const _0x14d8a6 = _0x45ea, _0x99c8b6 = { "tzRZh": function(_0x2b2618, _0x132bb4) {
    return _0x2b2618 !== _0x132bb4;
  }, "hMCPJ": _0x14d8a6(528), "acueK": _0x14d8a6(473), "GuQGY": function(_0x2f63fc, _0x3b41e2) {
    return _0x2f63fc !== _0x3b41e2;
  }, "hzOel": "number", "ytLvk": function(_0x25b81f, _0x580f1d) {
    return _0x25b81f <= _0x580f1d;
  }, "wJNfq": function(_0x81d9dd, _0x1bd515) {
    return _0x81d9dd in _0x1bd515;
  }, "XzCpw": _0x14d8a6(508), "WfIrW": function(_0x423e97, _0x4510a6) {
    return _0x423e97 in _0x4510a6;
  }, "DPvGr": function(_0x68d684, _0x476af1) {
    return _0x68d684 !== _0x476af1;
  }, "qQYET": _0x14d8a6(520), "vbZVb": _0x14d8a6(531), "QKwqY": _0x14d8a6(507), "UGPlM": _0x14d8a6(461), "otrWK": _0x14d8a6(472), "mbQKg": _0x14d8a6(470), "XPixs": _0x14d8a6(522), "GsTVz": "vLrAO", "SIjXp": function(_0x14a91d, _0x201aff) {
    return _0x14a91d !== _0x201aff;
  }, "rdMtN": 'Field "prices" must be a non-empty array', "ZOHmG": function(_0x22e757, _0x237dce) {
    return _0x22e757 !== _0x237dce;
  }, "qbgvt": function(_0x470714, _0x2fb695) {
    return _0x470714 !== _0x2fb695;
  }, "WtNOr": _0x14d8a6(471), "MghpW": _0x14d8a6(490), "LSakY": _0x14d8a6(521), "Avgum": _0x14d8a6(524), "CJKDQ": function(_0x576d8c, _0x427589) {
    return _0x576d8c in _0x427589;
  }, "fkEBR": "suggested_tip_amounts", "ryxyR": function(_0x2d73f1, _0x392698) {
    return _0x2d73f1 === _0x392698;
  }, "Vwxub": _0x14d8a6(479), "MngWC": 'Field "suggested_tip_amounts" must be an array if provided', "qWImT": "PxwiG", "wUJut": _0x14d8a6(460), "itiqB": _0x14d8a6(509), "oqRIP": "need_name", "KBKHZ": _0x14d8a6(494), "JgKdb": _0x14d8a6(474), "GEXnj": _0x14d8a6(489), "ruiOq": _0x14d8a6(525), "oFtDO": "qwxFv", "oONKa": function(_0x420591, _0x5b72e6) {
    return _0x420591 !== _0x5b72e6;
  }, "BFTxW": _0x14d8a6(506), "hsaZe": function(_0x2fead9, _0x25d1b4) {
    return _0x2fead9 === _0x25d1b4;
  }, "ZcxVD": _0x14d8a6(458) };
  if (!_0x4baa99) {
    if (_0x99c8b6[_0x14d8a6(469)] === _0x99c8b6[_0x14d8a6(457)]) throw new _0x128ddf(_0x14d8a6(510) + _0x1956dd + _0x14d8a6(511));
    else throw new Error(_0x99c8b6["QKwqY"]);
  }
  const _0x2c570d = [_0x99c8b6["UGPlM"], _0x99c8b6[_0x14d8a6(462)], _0x99c8b6[_0x14d8a6(517)], _0x14d8a6(481), _0x99c8b6[_0x14d8a6(503)]];
  for (const _0x16a919 of _0x2c570d) {
    if (_0x99c8b6[_0x14d8a6(478)] !== _0x99c8b6[_0x14d8a6(478)]) throw new _0x326889(_0x14d8a6(510) + _0x5d4560 + _0x14d8a6(485));
    else {
      if (!_0x4baa99[_0x16a919] || _0x99c8b6[_0x14d8a6(450)](typeof _0x4baa99[_0x16a919], _0x99c8b6[_0x14d8a6(502)])) throw new Error('Field "' + _0x16a919 + _0x14d8a6(485));
    }
  }
  if (!Array[_0x14d8a6(512)](_0x4baa99[_0x14d8a6(492)]) || _0x4baa99["prices"][_0x14d8a6(497)] === 0) throw new Error(_0x99c8b6[_0x14d8a6(445)]);
  for (const _0x3f69d2 of _0x4baa99[_0x14d8a6(492)]) {
    if (!_0x3f69d2[_0x14d8a6(499)] || _0x99c8b6["ZOHmG"](typeof _0x3f69d2[_0x14d8a6(499)], _0x99c8b6[_0x14d8a6(502)])) {
      if (_0x99c8b6["qbgvt"](_0x99c8b6[_0x14d8a6(515)], _0x99c8b6["WtNOr"])) throw new _0x38baa5(_0x14d8a6(510) + _0x32a231 + _0x14d8a6(527));
      else throw new Error(_0x99c8b6[_0x14d8a6(526)]);
    }
    if (_0x99c8b6[_0x14d8a6(466)](typeof _0x3f69d2[_0x14d8a6(459)], _0x99c8b6[_0x14d8a6(477)]) || _0x99c8b6[_0x14d8a6(453)](_0x3f69d2[_0x14d8a6(459)], 0)) throw new Error(_0x99c8b6[_0x14d8a6(495)]);
  }
  const _0x92377b = [_0x99c8b6[_0x14d8a6(463)], _0x99c8b6[_0x14d8a6(465)], _0x14d8a6(464), _0x99c8b6[_0x14d8a6(486)], _0x14d8a6(475)];
  for (const _0x3ef5dc of _0x92377b) {
    if (_0x99c8b6["CJKDQ"](_0x3ef5dc, _0x4baa99) && _0x99c8b6[_0x14d8a6(483)](typeof _0x4baa99[_0x3ef5dc], _0x14d8a6(455))) throw new Error(_0x14d8a6(510) + _0x3ef5dc + _0x14d8a6(511));
  }
  if (_0x99c8b6["wJNfq"](_0x99c8b6[_0x14d8a6(482)], _0x4baa99)) {
    if (_0x99c8b6[_0x14d8a6(500)](_0x99c8b6[_0x14d8a6(456)], _0x14d8a6(505))) {
      if (!_0x2d2218[_0x14d8a6(499)] || _0x99c8b6[_0x14d8a6(466)](typeof _0x3773d8[_0x14d8a6(499)], _0x99c8b6[_0x14d8a6(502)])) throw new _0x368bbe(_0x99c8b6["acueK"]);
      if (_0x99c8b6["GuQGY"](typeof _0x15ec59[_0x14d8a6(459)], _0x99c8b6[_0x14d8a6(477)]) || _0x99c8b6[_0x14d8a6(453)](_0x4377f3["amount"], 0)) throw new _0x165b4e('Each price must have a positive "amount" number');
    } else {
      if (!Array["isArray"](_0x4baa99[_0x14d8a6(454)])) throw new Error(_0x99c8b6[_0x14d8a6(498)]);
      for (const _0x35eea3 of _0x4baa99[_0x14d8a6(454)]) {
        if (_0x99c8b6["qWImT"] !== _0x99c8b6["wUJut"]) {
          if (typeof _0x35eea3 !== _0x99c8b6[_0x14d8a6(477)]) throw new Error(_0x99c8b6[_0x14d8a6(446)]);
        } else {
          if (_0x99c8b6[_0x14d8a6(484)](_0x37b3fd, _0x1b1498) && _0x99c8b6[_0x14d8a6(466)](typeof _0x244900[_0x5cc6f2], _0x14d8a6(455))) throw new _0x394c81('Field "' + _0x339947 + _0x14d8a6(511));
        }
      }
    }
  }
  const _0x26b5de = [_0x99c8b6[_0x14d8a6(448)], _0x14d8a6(467), _0x14d8a6(501), _0x99c8b6[_0x14d8a6(476)], _0x99c8b6[_0x14d8a6(529)], _0x99c8b6["GEXnj"], _0x14d8a6(523)];
  for (const _0x3b0eee of _0x26b5de) {
    if (_0x99c8b6[_0x14d8a6(519)] !== _0x99c8b6["oFtDO"]) {
      if (_0x99c8b6[_0x14d8a6(488)](_0x3b0eee, _0x4baa99) && _0x99c8b6[_0x14d8a6(452)](typeof _0x4baa99[_0x3b0eee], _0x99c8b6[_0x14d8a6(491)])) {
        if (_0x99c8b6[_0x14d8a6(518)](_0x99c8b6[_0x14d8a6(447)], _0x99c8b6[_0x14d8a6(447)])) throw new Error(_0x14d8a6(510) + _0x3b0eee + _0x14d8a6(527));
        else throw new _0x52c354(_0x99c8b6[_0x14d8a6(495)]);
      }
    } else {
      if (_0x99c8b6[_0x14d8a6(488)](_0x12dbb7, _0x4354e3) && _0x99c8b6["DPvGr"](typeof _0x1d7f72[_0x480143], _0x14d8a6(506))) throw new _0x548841(_0x14d8a6(510) + _0x44c111 + _0x14d8a6(527));
    }
  }
}
function _0x45ea(_0x3fcfc2, _0x5341b8) {
  const _0xe3b463 = _0xe3b4();
  return _0x45ea = function(_0x45ea75, _0x1ce286) {
    _0x45ea75 = _0x45ea75 - 445;
    let _0x15c873 = _0xe3b463[_0x45ea75];
    return _0x15c873;
  }, _0x45ea(_0x3fcfc2, _0x5341b8);
}
function _0xe3b4() {
  const _0x479c6b = ["prices", "88nsEQUE", "need_shipping_address", "XzCpw", "36xlWjqA", "length", "MngWC", "label", "ryxyR", "need_email", "hMCPJ", "XPixs", "6137187wdHneC", "bexDn", "boolean", "Payload is required", 'Each price must have a positive "amount" number', 'All values in "suggested_tip_amounts" must be numbers', 'Field "', '" must be a number if provided', "isArray", "3362435mzcNvD", "9514YcIOik", "WtNOr", "6MdRqgG", "mbQKg", "hsaZe", "ruiOq", "ZNPUq", "max_tip_amount", "currency", "is_flexible", "photo_width", "OdKlB", "acueK", '" must be a boolean if provided', "string", "JgKdb", "3104352vdKAkd", "arUUs", "rdMtN", "itiqB", "ZcxVD", "oqRIP", "657672xRsrxH", "SIjXp", "153wyRCNh", "oONKa", "ytLvk", "suggested_tip_amounts", "number", "Vwxub", "vbZVb", "picNV", "amount", "xYsND", "slug", "otrWK", "MghpW", "photo_size", "LSakY", "tzRZh", "need_phone_number", "7307690KdIyLs", "qQYET", "description", "ssjiz", "title", 'Each price must have a "label" string', "send_phone_number_to_provider", "photo_height", "KBKHZ", "hzOel", "GsTVz", "LeuWz", "215169fJqhFB", "payload", "fkEBR", "GuQGY", "wJNfq", '" is required and must be a string', "Avgum", "67RQHaIs", "WfIrW", "send_email_to_provider", "subscription_period", "BFTxW"];
  _0xe3b4 = function() {
    return _0x479c6b;
  };
  return _0xe3b4();
}
function _0x5e36(_0x4972ab, _0xad02c0) {
  const _0x58c5e4 = _0x58c5();
  return _0x5e36 = function(_0x5e367c, _0x55ea91) {
    _0x5e367c = _0x5e367c - 403;
    let _0x33ef2c = _0x58c5e4[_0x5e367c];
    return _0x33ef2c;
  }, _0x5e36(_0x4972ab, _0xad02c0);
}
const _0x209ab5 = _0x5e36;
(function(_0x35a768, _0x5a8370) {
  const _0x1b3b4e = _0x5e36, _0x525a98 = _0x35a768();
  while (!![]) {
    try {
      const _0x15a2c6 = parseInt(_0x1b3b4e(403)) / 1 * (-parseInt(_0x1b3b4e(407)) / 2) + parseInt(_0x1b3b4e(406)) / 3 + -parseInt(_0x1b3b4e(415)) / 4 * (-parseInt(_0x1b3b4e(411)) / 5) + -parseInt(_0x1b3b4e(409)) / 6 * (parseInt(_0x1b3b4e(410)) / 7) + -parseInt(_0x1b3b4e(404)) / 8 * (-parseInt(_0x1b3b4e(412)) / 9) + -parseInt(_0x1b3b4e(405)) / 10 * (-parseInt(_0x1b3b4e(413)) / 11) + -parseInt(_0x1b3b4e(408)) / 12;
      if (_0x15a2c6 === _0x5a8370) break;
      else _0x525a98["push"](_0x525a98["shift"]());
    } catch (_0x8998fc) {
      _0x525a98["push"](_0x525a98["shift"]());
    }
  }
})(_0x58c5, 208848);
function _0x58c5() {
  const _0x329600 = ["151736gUGEpm", "1900SrwxAV", "354954avGqYo", "28lJXoNP", "3199740zSYPxN", "6mQDOth", "164017ZSdbmp", "9640Atevbf", "18yMvNml", "17105GsaABt", "PROD", "308LARpXH", "VvuNb", "7231fLefVA"];
  _0x58c5 = function() {
    return _0x329600;
  };
  return _0x58c5();
}
let __registerInvoice;
async function init({ token: _0x5e449f, appName: _0x1a1bb9, env = _0x209ab5(414) }) {
  const _0x13d452 = { "VvuNb": function(_0xb24e29, _0x591506) {
    return _0xb24e29(_0x591506);
  } }, _0x43dee1 = new App(_0x5e449f, _0x1a1bb9, env);
  __registerInvoice = (_0x28052e) => {
    const _0x45bd39 = _0x5e36;
    _0x13d452[_0x45bd39(416)](validateInvoicePayload, _0x28052e), _0x43dee1["registerInvoice"](_0x28052e);
  }, await _0x43dee1["init"]();
}
const index = { "init": init, "registerInvoice": (_0x13636d) => __registerInvoice(_0x13636d) };
export {
  index as default
};
